import React, { useEffect } from 'react';
import svgpanzoom from 'svg-pan-zoom';
import './PLCNextBasicDeviceStyle.css';
import get from 'lodash.get';
let schematicDiagram = null;
const styleSensorRed = 'ver1-sen-red';
const styleSensorOrange = 'ver1-sen-amber';
const styleSensorGreen = 'ver1-sen-green_dark';
const styleSensorWhite = 'ver1-sen-white';
const styleSensorYellow = 'ver1-sen-yellow';
const styleLineReset = 'ver1-line-reset';
const styleTankFillBlue = 'ver1-sen-tank-blue';
const styleLineDarkBlue = 'ver1-line-blue_dark';

const AlgaesysSvg = sensorData => {

   //Ball valves
   //===========
   let { ShowSensors, componentsInfo, siteAssociations, unitId, resetDiagram } = sensorData;

   let clsshowsensor = ShowSensors ? 'show-sensor' : 'hide-sensor'; // conditional show/hide sensor value with middle anchor
   let clsshowsensorla = `${clsshowsensor} leftanchor` // left anchor for sensor labels
   let clslabeltext = ''  // Always show label
   let clsvaluetext = 'midanchor' // Always show valve text with middle anchor
   let clsshowsensorlabel = ShowSensors ? '' : 'hide-sensor'; // conditional show/hide label
   let clslegendlabel = '' // Always show legend label
   let clslegendvalue = 'midanchor' // Always show legend value

   const svgElement = document.querySelector('#dv-schematics');
   var options = {
      zoomEnabled: true,
      mouseWheelZoomEnabled: sensorData.enableMouseZoom,
      controlIconsEnabled: true,

      fit: true,
      center: true,
      contain: true
   };

   if (svgElement) {
      schematicDiagram = svgpanzoom(svgElement, options);

      if (sensorData.enableMouseZoom) {
         schematicDiagram.enableMouseWheelZoom();
      } else {
         schematicDiagram.disableMouseWheelZoom();
      }
   }

   const onResize = () => {
      if (schematicDiagram) {
         // schematicDiagram.reset();
         schematicDiagram.resize();
      }
   };

   useEffect(() => {
      window.addEventListener('resize', onResize);
   }, [onResize]); // Only initialize listener on initial render

   useEffect(() => {
      if (resetDiagram && schematicDiagram) {
         schematicDiagram.reset();
      }
   }, [resetDiagram]);

   // Current State
   let sequenceState = sensorData && sensorData.SensorData && sensorData.SensorData && sensorData.SensorData.current_state;

   //helper functions to swap sensor value and label

   const swapSensorAndLabel = (sensorName, labelValue) => {
      const sensorValue = getSensorValue(sensorName);
      if (ShowSensors) {
         if (sensorValue !== '') {
            return sensorValue + ' ' + getUoM(sensorName);

         } else {
            return "N/A"
         }
      } else {
         return labelValue
      }
   }

   // valve state data
   // Helper function to get valve state
   const getValveState = (valveName) => {
      const valveData = sensorData?.SensorData;
      if (!valveData) return null;

      if (valveData[`${valveName}_undefined`] === 1) return 'undefined';
      if (valveData[`${valveName}_closed`] === 1 && valveData[`${valveName}_open`] === 1) return 'undefined';
      if (valveData[`${valveName}_closed`] === 1) return 'closed';
      if (valveData[`${valveName}_open`] === 1) return 'open';

      return null;
   };

   const getSensorValue = (sensorName) => {
      const sensorInfo = sensorData?.SensorData;
      if (!sensorInfo) return '';
      return sensorInfo[sensorName] ?? '';
   };

   const getGeneralSensorStyle = (val) => {
      return val === undefined
         ? styleSensorOrange
         : val === 0
            ? ''
            : val === 1
               ? styleSensorGreen
               : styleSensorWhite;
   }

   const getValveStyle = (val) => {
      return val === undefined
         ? styleSensorOrange
         : val === 'closed'
            ? styleLineReset
            : val === 'open'
               ? styleSensorGreen
               : styleSensorOrange;
   }

   const getUoM = (sensorName) => {
      const sensor = componentsInfo.find(comp => comp.Name === sensorName.toUpperCase());
      return sensor ? sensor.UoM : '';
   }

   const getTitle = (sensorName) => {
      const sensor = componentsInfo.find(comp => comp.Name.toUpperCase() === sensorName.toUpperCase());
      return sensor ? toTitleCase(sensor.Title) : '';
   }

   const toTitleCase = (str) => {
      return str
         .toLowerCase()
         .replace(/\b\w/g, c => c.toUpperCase());
   }

   const getTtitleSwapSensorAndLabel = (sensorName, labelValue) => {
      return <> {ShowSensors &&
         <title>
            {getTitle(sensorName)}
         </title>}
         <tspan>
            {swapSensorAndLabel(sensorName, labelValue)}
         </tspan>
      </>;

   }

   const getTtitleAndSensorValue = (sensorName) => {
      let sensorValue = getSensorValue(sensorName);
      if (sensorValue !== '') {
         sensorValue = sensorValue + ' ' + getUoM(sensorName);
      } else {
         sensorValue = 'N/A'
      }
      return <> <title>
         {ShowSensors &&
            <title>
               {getTitle(sensorName)}
            </title>}
      </title>
         <tspan>
            {sensorValue}
         </tspan>
      </>;

   }

   const getSchematicStyles = () => {
      return (
         <style>
            {`
               #dv-schematics path,
               #dv-schematics rect,
               #dv-schematics circle,
               #dv-schematics ellipse {
                  stroke-width: 1.3 !important;
               }
         `}
         </style>
      );
   };

   const getTankFillGradient = (tankId, lowValue = null, highValue = null, stopColor = "#00bfff") => {
      // Determine fill percentage based on alarm levels
      let fillPercent = 60;

      if (highValue === 1) {
         fillPercent = 90;
      } else if (lowValue === 1) {
         fillPercent = 25;
      }

      // Create gradient stops based on fill level
      const transitionPoint = fillPercent; // Where color changes
      const transitionWidth = 10; // Smooth transition over 10%

      return (
         <linearGradient id={`${tankId}fill`} x1="0%" y1="100%" x2="0%" y2="0%">
            <stop offset="0%" stopColor={stopColor} />
            <stop offset={`${Math.max(0, fillPercent - transitionWidth)}%`} stopColor={stopColor} />
            <stop offset={`${fillPercent}%`} stopColor="#fff" />
            <stop offset="100%" stopColor="#fff" />
         </linearGradient>
      );
   };

   const b02_speednormal = getSensorValue('b02_speednormal');
   const b02_speedsparging = getSensorValue('b02_speedsparging');
   const fcv01_sewagelineflushactive = getSensorValue('fcv01_sewagelineflushactive');
   const fcv01_sewagelineflushinactive = getSensorValue('fcv01_sewagelineflushinactive');
   const t02_high = getSensorValue('t02_high');
   const t03_high = getSensorValue('t03_high');
   const t04_high = getSensorValue('t04_high');
   const t04_highhigh = getSensorValue('t04_highhigh');
   const t05_low = getSensorValue('t05_low');
   const t06_low = getSensorValue('t06_low');
   const t06_high = getSensorValue('t06_high');
   const t08_high = getSensorValue('t08_high');
   const t08_highhigh = getSensorValue('t08_highhigh');
   const t08_low = getSensorValue('t08_low');
   const t08_lowlow = getSensorValue('t08_lowlow');
   const t08_lowlowbackwashinterlock = getSensorValue('t08_lowlowbackwashinterlock');
   const t08_lowlowwashdownpumpinterlock = getSensorValue('t08_lowlowwashdownpumpinterlock');
   const t09_low = getSensorValue('t09_low');

   const ae01a2_phlevellow = getSensorValue('ae01a2_phlevellow');
   const ae02_turbidityhigh = getSensorValue('ae02_turbidityhigh');
   const ae03a_freechlorineresiduallow = getSensorValue('ae03a_freechlorineresiduallow');
   const ae03a_freechlorineresiduallowlow = getSensorValue('ae03a_freechlorineresiduallowlow');
   const mv01_open = getSensorValue('mv01_open');
   const mv02_open = getSensorValue('mv02_open');
   const mv03_positionbackwash = getSensorValue('mv03_positionbackwash');
   const mv03_positionfiltering = getSensorValue('mv03_positionfiltering');
   const mv04_positiontreatedwatertank = getSensorValue('mv04_positiontreatedwatertank');
   const mv04_positionrecirculate = getSensorValue('mv04_positionrecirculate');
   const p01_running = getSensorValue('p01_running');
   const p02_running = getSensorValue('p02_running');
   const p03_alarmactive = getSensorValue('p03_alarmactive');
   const p03_running = getSensorValue('p03_running');
   const p04_running = getSensorValue('p04_running');
   const p05_running = getSensorValue('p05_running');
   const p06_running = getSensorValue('p06_running');
   const p07_running = getSensorValue('p07_running');
   const clsys01_alarmactive = getSensorValue('clsys01_alarmactive');
   const p08_running = getSensorValue('p08_running');
   const p09_running = getSensorValue('p09_running');
   const p10_running = getSensorValue('p10_running');

   const ae01a_do_1 = getTtitleSwapSensorAndLabel('ae01a1_dissolvedoxygen', 'AE01A DO');

   const ae01a_orp_ph_1 = getTtitleAndSensorValue('ae01a2_orp');
   const ae01a_orp_ph_2 = getTtitleAndSensorValue('ae01a2_ph');
   const ae01a_orp_ph_3 = getTtitleAndSensorValue('ae01a2_temperature');

   const ae01b_do_1 = getTtitleSwapSensorAndLabel('ae01b1_dissolvedoxygen', 'AE01B DO');
   const ae01b_orp_ph_1 = getTtitleAndSensorValue('ae01b2_orp');
   const ae01b_orp_ph_2 = getTtitleAndSensorValue('ae01b2_ph');
   const ae01b_orp_ph_3 = getTtitleAndSensorValue('ae01b2_temperature');

   const ae02_1 = getTtitleSwapSensorAndLabel('ae02_turbidity', 'AE02');
   const ae03a_1 = getTtitleAndSensorValue('ae03a_freechlorineresidual');
   const ae03b_1 = getTtitleAndSensorValue('ae03b_ph');

   const b02_1 = b02_speedsparging == 1 ? "Sparging" : ""

   const fcv01_1 = fcv01_sewagelineflushactive == 1 ? "Flushing" : "Flow Control";

   const ft01_1 = getTtitleAndSensorValue("ft01_flowrate", "");

   const ls01_1 = t02_high == 1 ? 'HIGH' : '';
   const ls02_1 = t03_high == 1 ? 'HIGH' : '';
   const ls03_1 = t05_low == 1 ? 'LOW' : '';
   const ls04_1 = t04_highhigh == 1 ? 'HIGHHIGH' : t04_high == 1 ? 'HIGH' : '';
   const ls05_1 = t06_high == 1 ? 'HIGH' : t06_low == 1 ? 'LOW' : '';
   const ls07_1 = t08_lowlowbackwashinterlock == 1 || t08_lowlowwashdownpumpinterlock == 1 ? "LOWLOW" : t08_low == 1 ? "LOW" : t08_high == 1 ? "HIGH" : t08_highhigh == 1 ? "HIGHHIGH" : "";
   const ls08_1 = t09_low == 1 ? 'LOW' : '';

   const p03_1 = ' ';
   const p08_1 = ' ';

   const waste_water_body = styleTankFillBlue;


   const clsae01a_do_body = 'clsae01a_do_body ';
   const clsae01a_orp_ph_body = ae01a2_phlevellow == 1 ? styleSensorYellow : 'clsae01a_orp_ph_body ';
   const clsae01b_do_body = 'clsae01b_do_body ';
   const clsae01b_orp_ph_body = 'clsae01b_orp_ph_body ';
   const clsae02_turbidity_body = ae02_turbidityhigh == 1 ? styleSensorYellow : 'clsae02_turbidity_body ';

   let clsae03a_cl_body = ae03a_freechlorineresiduallow == 1 ? styleSensorYellow : 'clsae03a_cl_body ';
   clsae03a_cl_body = ae03a_freechlorineresiduallowlow == 1 ? styleSensorRed : 'clsae03a_cl_body ';
   const clsae03b_ph_body = 'clsae03b_ph_body ';
   const clsb01_body = 'clsb01_body ';
   const clsb01_line_out = 'clsb01_line_out ';
   const clsb02_body = b02_speednormal == 1 || b02_speedsparging == 1 ? styleSensorGreen : 'clsb02_body ';
   const clscds_body = 'clscds_body ';
   const clsdashline = 'clsdashline ';
   const clsdpi01_body = 'clsdpi01_body ';
   const clsfcv01_body = fcv01_sewagelineflushactive == 1 || fcv01_sewagelineflushinactive == 1 ? styleSensorGreen : 'clsfcv01_body ';

   const clsft01_body = 'clsft01_body ';
   const clshv01_body = 'clshv01_body ';
   const clshv02_body = 'clshv02_body ';
   const clshv02_line_in = 'clshv02_line_in ';
   const clshv03_body = 'clshv03_body ';

   const clshv04_body = 'clshv04_body ';

   const clshv05_body = 'clshv05_body ';
   const clshv06_body = 'clshv06_body ';

   const clshv07_body = 'clshv07_body ';
   const clshv08_body = 'clshv08_body ';
   const clshv09_body = 'clshv09_body ';

   const clshv10_body = 'clshv10_body ';
   const clshv11_body = 'clshv11_body ';
   const clshv11_line_out = 'clshv11_line_out ';
   const clshv12_body = 'clshv12_body ';
   const clshv13_body = 'clshv13_body ';
   const clshv14_body = 'clshv14_body ';
   const clshv15_body = 'clshv15_body ';
   const clshv16_body = 'clshv16_body ';
   const clshv16_line_in = 'clshv16_line_in ';
   const clshv16_line_out = 'clshv16_line_out ';
   const clshv17_body = 'clshv17_body ';
   const clshv18_body = 'clshv18_body ';

   const clshv19_body = 'clshv19_body ';
   const clshv20_body = 'clshv20_body ';
   const clshv21_body = 'clshv21_body ';

   const clshv22_body = 'clshv22_body ';

   const clshv23_body = 'clshv23_body ';
   const clshv24_body = 'clshv24_body ';
   const clshv25_body = 'clshv25_body ';
   const clshv26_body = 'clshv26_body ';
   const clshv27_body = 'clshv27_body ';
   const clshv28_body = 'clshv28_body ';
   const clshv29_body = 'clshv29_body ';
   const clshv30_body = 'clshv30_body ';
   const clsline = 'clsline ';

   const clsls01_body = t02_high == 1 ? styleSensorYellow : 'clsls01_body ';
   const clsls02_body = t03_high == 1 ? styleSensorYellow : 'clsls02_body ';
   const clsls03_body = t05_low == 1 ? styleSensorYellow : 'clsls03_body ';
   const clsls04_body = t04_highhigh == 1 ? styleSensorRed : t04_high == 1 ? styleSensorYellow : 'clsls04_body ';
   const clsls05_body = t06_low == 1 || t06_high == 1 ? styleSensorYellow : 'clsls05_body ';
   let clsls07_body = t08_high == 1 || t08_low == 1 ? styleSensorYellow : 'clsls07_body';
   clsls07_body = t08_highhigh == 1 || t08_lowlowbackwashinterlock == 1 || t08_lowlowwashdownpumpinterlock == 1 ? styleSensorRed : 'clsls07_body';
   const clsls08_body = t09_low == 1 ? styleSensorYellow : 'clsls08_body ';

   const clsmmf_body = 'clsmmf_body ';
   const clsmv01_body = mv01_open == 1 ? styleSensorGreen : 'clsmv01_body ';
   const clsmv02_body = mv02_open == 1 ? styleSensorGreen : 'clsmv02_body ';

   const clsmv03_backwash = mv03_positionbackwash == 1 ? styleSensorGreen : 'clsmv03_backwash ';
   const clsmv03_filtering = mv03_positionfiltering == 1 ? styleSensorGreen : 'clsmv03_filtering ';
   const clsmv03_common = mv03_positionbackwash == 1 || mv03_positionfiltering == 1 ? styleSensorGreen : 'clsmv03_common ';

   const clsmv04_treatedwater = mv04_positiontreatedwatertank == 1 ? styleSensorGreen : 'clsmv04_treatedwater ';

   const clsmv04_common = mv04_positionrecirculate == 1 || mv04_positiontreatedwatertank == 1 ? styleSensorGreen : 'clsmv04_common ';
   const clsmv04_recirculate = mv04_positionrecirculate == 1 ? styleSensorGreen : 'clsmv04_recirculate ';

   const clsp01_body = p01_running == 1 ? styleSensorGreen : 'clsp01_body ';
   const clsp02_body = p02_running == 1 ? styleSensorGreen : 'clsp02_body ';
   const clsp03_body = p03_alarmactive == 1 ? styleSensorRed : p03_running == 1 ? styleSensorGreen : 'clsp03_body ';
   const clsp04_body = p04_running == 1 ? styleSensorGreen : 'clsp04_body ';
   const clsp05_body = p05_running == 1 ? styleSensorGreen : 'clsp05_body ';

   const clsp06_body = p06_running == 1 ? styleSensorGreen : 'clsp06_body ';

   const clsp07_body = p07_running == 1 ? styleSensorGreen : 'clsp07_body ';

   const clsp08_body = clsys01_alarmactive == 1 ? styleSensorRed : 'clsp08_body ';

   const clsp09_body = p09_running == 1 ? styleSensorGreen : 'clsp09_body ';
   const clsp10_body = p10_running == 1 ? styleSensorGreen : 'clsp10_body ';




   const clsp11_body = 'clsp11_body ';
   const clspagetext = 'clspagetext ';
   const clspi021_body = 'clspi021_body ';
   const clsscreening_body = 'clsscreening_body ';

   const clst01_body = 'clst01_body ';

   const clst02_body = 'clst02_body ';
   const clst03_body = 'clst03_body ';
   const clst03_bottom_2 = styleTankFillBlue;
   const clst03_bottom_1 = styleTankFillBlue;

   const clst04_body = 'clst04_body ';
   const clst05_body = 'clst05_body ';
   const clst06_body = 'clst06_body ';
   const clst08_body = 'clst08_body ';
   const clst09_body = 'clst09_body ';
   const clsto_irrigation_body = 'clsto_irrigation_body ';
   const clspc02_body = 'clspc02_body ';
   const clspc01_body = 'clspc01_body ';




   //Line styles
   //*************/
   const clswaste_water_out = styleLineDarkBlue;
   const clsp01_line_out_1 = p01_running == 1 ? styleLineDarkBlue : '';
   const clsp02_line_out = p02_running == 1 ? styleLineDarkBlue : '';
   const clsp01_line_out_2 = clsp01_line_out_1
   const clsfcv01_line_in = clsp01_line_out_2 || clsp02_line_out || ''
   const clsfcv01_line_out = fcv01_sewagelineflushactive == 1 || fcv01_sewagelineflushinactive == 1 ? clsfcv01_line_in : '';

   //Alaesys tank t03 to  p05 line
   const clshv03_line_in = styleLineDarkBlue;
   const clsp05_line_in = clshv03_line_in;
   const clsp05_line_out = p05_running == 1 ? clsp05_line_in : '';

   const clsscreening_line_out = clsfcv01_line_out || clsp05_line_out || '';
   const clspc01_line_out = mv01_open != 1 ? clsscreening_line_out : ''
   const clst03_line_in = clspc01_line_out;

   // PH CONTROL PRECONDITIONING CHEMICAL 
   const clsp03_line_out = p03_running == 1 ? styleLineDarkBlue : '';



   //blower 02 line
   const clsb02_line_out = b02_speednormal == 1 || b02_speedsparging == 1 ? styleLineDarkBlue : ''

   const clshv04_line_in = styleLineDarkBlue;
   const clshv04_line_out = clshv04_line_in;

   const clshv05_line_in = clshv04_line_out;
   const clshv06_line_in = clshv04_line_out;

   const clsp06_line_in = clshv06_line_in;
   const clsp06_line_out = p06_running == 1 ? clsp06_line_in : '';

   const clsmv02_line_in = styleLineDarkBlue;

   //Primary clarifier 1 and 2 to Waste tank line
   const clsmv02_line_out = mv02_open == 1 ? clsmv02_line_in : '';
   const clsp04_line_in_3 = clsmv02_line_out;
   const clsmv01_line_in = styleLineDarkBlue;
   const clsmv01_line_out = p04_running == 1 ? clsmv01_line_in : '';
   const clsp04_line_in_1 = clsmv01_line_out;

   const clsp04_line_in_2 = clsp04_line_in_1 || clsp04_line_in_3
   const clsp04_line_out = p04_running == 1 ? clsmv01_line_in : ''


   //clarifier 2 to t06 line
   const clst06_line_in = mv02_open != 1 || p04_running != 1 ? clsp06_line_out : '';

   const clshv07_line_in = styleLineDarkBlue;

   //T06 out to mv-03
   const clsmv03_filtering_line_in = mv03_positionfiltering == 1 && t06_low != 1 && p09_running == 1 ? styleLineDarkBlue : '';

   // t08 to p09 line

   const clst08_line_out = ls07_1 != 'LOWLOW' && (p10_running == 1 || (p09_running == 1 && mv03_positionbackwash == 1) || p07_running == 1) ? styleLineDarkBlue : ''
   const clshv17_line_out = clst08_line_out
   const clshv18_line_in = p10_running == 1 || p07_running == 1 ? clshv17_line_out : '';

   const clsp10_line_in = p10_running == 1 ? clshv18_line_in : '';
   const clsp10_line_out = clsp10_line_in;
   const clshv19_line_out = clsp10_line_out
   const clshv20_line_out = clsp10_line_out;
   const clshv21_line_in = p07_running == 1 ? clshv18_line_in : '';
   const clsp07_line_in = clshv21_line_in;
   const clsp07_line_out = clsp07_line_in;
   const clshv22_line_out = clsp07_line_out;



   const clsmv03_backwash_line_in = p09_running == 1 && mv03_positionbackwash == 1 ? clshv17_line_out : '';
   const clsmv03_common_line_out =
      p09_running === 1 &&
         (mv03_positionfiltering === 1 || mv03_positionbackwash === 1) &&
         (
            clsmv03_filtering_line_in === styleLineDarkBlue ||
            clsmv03_backwash_line_in === styleLineDarkBlue
         )
         ? styleLineDarkBlue
         : '';


   //p09 outline
   const clsp09_line_out = clsmv03_common_line_out;






   const clshv08_line_out = clsp09_line_out
   const clshv09_line_in = clshv08_line_out || '';
   const clshv10_line_in = clshv08_line_out || '';
   const clshv10_line_out = mv03_positionbackwash == 1 ? clshv10_line_in : '';
   const clshv09_line_out = mv03_positionfiltering == 1 ? clshv09_line_in : '';
   const clshv11_line_in_1 = clshv09_line_out;
   const clshv11_line_in_2 = clshv11_line_in_1;
   const clshv12_line_in = clshv09_line_out
   const clshv13_line_in = clshv09_line_out;
   const clshv13_line_out = clshv13_line_in;

   const clsdpi01_line_out = clshv09_line_in;


   const clswmv04_common_line_in = clshv12_line_in;

   //Treated water tank in
   const clsmv04_treatedwater_line_out = mv04_positiontreatedwatertank == 1 ? clswmv04_common_line_in : '';

   const clsmv04_recirculate_line_out = mv04_positionrecirculate == 1 ? clswmv04_common_line_in : '';
   const clst01_line_in = clsmv04_recirculate_line_out || clshv10_line_out || '';
   const clsp08_line_out = '';
   const clshv15_line_out = clsmv04_treatedwater_line_out;
   const clstk08_line_in = clshv15_line_out || clshv20_line_out || '';
   const p09_line_in = 'p09_line_in ';
   const p11_line_out = 'p11_line_out ';


   // Tank fill calculations 
   let tk04_fillhigh = t04_highhigh || t04_high || 0;
   let tk08_fillhigh = t08_highhigh || t08_high || 0;
   let tk08_filllow = t08_lowlow || t08_low || 0;

   let pc02_fillhigh = (mv02_open != 1 || p04_running != 1) && clsp06_line_out != '' ? 1 : 0;
   let pc02_filllow = (mv02_open == 1 && p04_running == 1) ? 1 : 0;

   let pc01_fillhigh = (mv01_open != 1 || p04_running != 1) && clsscreening_line_out != '' ? 1 : 0;
   let pc01_filllow = (mv01_open == 1 && p04_running == 1) ? 1 : 0;

   //Legend values
   const par02_ppfd = getSensorValue('par02_ppfd') !== '' ? getSensorValue('par02_ppfd') + ' ' + getUoM('par02_ppfd') : 'N/A';
   const par01_ppfd = getSensorValue('par01_ppfd') !== '' ? getSensorValue('par01_ppfd') + ' ' + getUoM('par01_ppfd') : 'N/A';
   const pwr01_powertotal = getSensorValue('pwr01_powertotal') !== '' ? getSensorValue('pwr01_powertotal') + ' ' + getUoM('pwr01_powertotal') : 'N/A';



   /*
    ********************************************* SVG TO SVGR CONVERSION***************************************

      Use SVG converter from utilities folder to convert SVG to JSX format

     Step  1: Move to folder SVGGeneration\input and copy the source SVG file 
     Step  2: Fire the command  python svg_to_svgr_converter.py .\source\ -o .\output\

     Step  3: Copy the SVG section from output file and paste it below

     Step  4: Replace viewbox with 
               viewBox="-150 120 1800 900" 

     Step  5: Add below code directly after opening svg tag to set stroke width globally, if its missing
              {getSchematicStyles()}

     Step  6: Add below code in defs section for tank fill gradients, if its missing
            {getTankFillGradient('tk01')}
            {getTankFillGradient('tk02', null, getSensorValue('t02_high'))}
            {getTankFillGradient('tk02', null, getSensorValue('t02_high'))}
            {getTankFillGradient('tk03', null, getSensorValue('t03_high'))}
            {getTankFillGradient('tk04', null, tk04_fillhigh)}
            {getTankFillGradient('tk05', getSensorValue('t05_low'), getSensorValue('t05_low') == 0 ? 1 : null)}
            {getTankFillGradient('tk06', getSensorValue('t06_low'), getSensorValue('t06_high'))}
            {getTankFillGradient('tk08', tk08_filllow, tk08_fillhigh)}
            {getTankFillGradient('pc01', pc01_filllow, pc01_fillhigh)}
            {getTankFillGradient('pc02', pc02_filllow, pc02_fillhigh)}
            


 
   */

   return (
      <svg
         width="100%"
         height="100%"
         viewBox="-150 120 1800 900"
         id="dv-schematics"
         xmlSpace="preserve"
         xmlnsXlink="http://www.w3.org/1999/xlink"
      >
         {getSchematicStyles()}
         <defs
            id="defs1"><rect
               x="830.03377"
               y="534.16351"
               width="78.59054"
               height="48.33108"
               id="rect3" />



            {getTankFillGradient('tk01', null, null, '#D1855C')}
            {getTankFillGradient('tk02', null, getSensorValue('t02_high'))}
            {getTankFillGradient('tk02', null, getSensorValue('t02_high'))}
            {getTankFillGradient('tk03', null, getSensorValue('t03_high'))}
            {getTankFillGradient('tk04', null, tk04_fillhigh, '#94A378')}
            {getTankFillGradient('tk05', getSensorValue('t05_low'), getSensorValue('t05_low') == 0 ? 1 : null)}
            {getTankFillGradient('tk06', getSensorValue('t06_low'), getSensorValue('t06_high'))}
            {getTankFillGradient('tk08', tk08_filllow, tk08_fillhigh, '#446ec2ff')}

            {getTankFillGradient('pc01', pc01_filllow, pc01_fillhigh)}
            {getTankFillGradient('pc02', pc02_filllow, pc02_fillhigh)}
            <rect
               x="314.36216"
               y="214.33784"
               width="1.8912162"
               height="19.962838"
               id="rect2" />
            <marker
               style={{
                  overflow: 'visible'
               }}
               id="marker1"
               refX="0"
               refY="0"
               orient="auto-start-reverse"
               markerWidth="1"
               markerHeight="1"
               viewBox="0 0 1 1"
               preserveAspectRatio="xMidYMid">
               <path
                  transform="scale(0.5)"
                  style={{
                     fill: 'context-stroke',
                     fillRule: 'evenodd',
                     stroke: 'context-stroke',
                     strokeWidth: '1pt'
                  }}
                  d="M 5.77,0 -2.88,5 V -5 Z"
                  id="path1" />
            </marker>
            <marker
               style={{
                  overflow: 'visible'
               }}
               id="Triangle"
               refX="0"
               refY="0"
               orient="auto-start-reverse"
               markerWidth="1"
               markerHeight="1"
               viewBox="0 0 1 1"
               preserveAspectRatio="xMidYMid">
               <path
                  transform="scale(0.5)"
                  style={{
                     fill: 'context-stroke',
                     fillRule: 'evenodd',
                     stroke: 'context-stroke',
                     strokeWidth: '1pt'
                  }}
                  d="M 5.77,0 -2.88,5 V -5 Z"
                  id="path135" />
            </marker>
            <rect
               x="174.08318"
               y="247.6362"
               width="54.415405"
               height="52.801388"
               id="rect1" />
            <rect
               x="179.62978"
               y="769.13995"
               width="12.169575"
               height="16.168966"
               id="rect3073" />
            <linearGradient
               id="swatch3063">
               <stop
                  style={{
                     stopColor: '#000000',
                     stopOpacity: 1
                  }}
                  offset="0"
                  id="stop3063" />
            </linearGradient>
            <rect
               x="848.7876"
               y="854.49402"
               width="10.597617"
               height="36.847099"
               id="rect3062" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061" />
            <rect
               x="950.88611"
               y="831.9101"
               width="25.363111"
               height="45.653603"
               id="rect3060" />
            <rect
               x="990.08368"
               y="700.48303"
               width="40.119831"
               height="43.809013"
               id="rect3059" />
            <rect
               x="965.64282"
               y="711.08942"
               width="17.062456"
               height="56.721142"
               id="rect3058" />
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath4">
               <path
                  d="m 23828.5,-17589.801 v -366 h 107.5 v 366 z"
                  transform="translate(-23828.501,17679.4)"
                  clipRule="evenodd"
                  id="path4" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath6">
               <path
                  d="m 19573.801,-17589.801 v -366 h 148.398 v 366 z"
                  transform="translate(-19573.8,17679.4)"
                  clipRule="evenodd"
                  id="path6" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath8">
               <path
                  d="m 15342.1,-17589.801 v -366 h 148.5 v 366 z"
                  transform="translate(-15342.1,17679.4)"
                  clipRule="evenodd"
                  id="path8" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath10">
               <path
                  d="m 11097.6,-17589.801 v -366 h 171.5 v 366 z"
                  transform="translate(-11097.6,17679.4)"
                  clipRule="evenodd"
                  id="path10" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath12">
               <path
                  d="m 6876.1602,-17589.801 v -366 h 148.4799 v 366 z"
                  transform="translate(-6876.1602,17679.4)"
                  clipRule="evenodd"
                  id="path12" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath14">
               <path
                  d="m 2641.9199,-17589.801 v -366 h 148.48 v 366 z"
                  transform="translate(-2641.92,17679.4)"
                  clipRule="evenodd"
                  id="path14" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath29">
               <path
                  d="m 23828.5,-2.56 v -384 h 107.5 v 384 z"
                  transform="translate(-23828.501,64)"
                  clipRule="evenodd"
                  id="path29" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath31">
               <path
                  d="m 19573.801,-2.56 v -384 h 148.398 v 384 z"
                  transform="translate(-19573.8,64)"
                  clipRule="evenodd"
                  id="path31" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath33">
               <path
                  d="m 15342.1,-2.56 v -384 h 148.5 v 384 z"
                  transform="translate(-15342.1,64)"
                  clipRule="evenodd"
                  id="path33" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath35">
               <path
                  d="m 11097.6,-2.56 v -384 h 171.5 v 384 z"
                  transform="translate(-11097.6,64)"
                  clipRule="evenodd"
                  id="path35" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath37">
               <path
                  d="m 6876.1602,-2.56 v -384 h 148.4799 v 384 z"
                  transform="translate(-6876.1602,64)"
                  clipRule="evenodd"
                  id="path37" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath39">
               <path
                  d="m 2641.9199,-2.56 v -384 h 148.48 v 384 z"
                  transform="translate(-2641.92,64)"
                  clipRule="evenodd"
                  id="path39" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath361">
               <path
                  d="m 160.32001,932.79999 h 72 v 119.51991 h -72 z"
                  transform="matrix(0.01388889,0,0,0.0083668,-2.2266668,-7.8045511)"
                  clipRule="evenodd"
                  id="path361" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath373">
               <path
                  d="m 160.32001,1107.52 h 38.07998 v 160.32 h -38.07998 z"
                  transform="matrix(0.0262605,0,0,0.00623752,-4.2100841,-6.9081838)"
                  clipRule="evenodd"
                  id="path373" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath662">
               <path
                  d="M 240.16,94.720001 V 1568.3199 h 863.2 V 94.720001 Z"
                  transform="translate(-683.20001,-605.76001)"
                  clipRule="evenodd"
                  id="path662" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath664">
               <path
                  d="M 240.16,94.720001 V 1568.3199 h 863.2 V 94.720001 Z"
                  clipRule="evenodd"
                  id="path664" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath666">
               <path
                  d="M 240.16,94.720001 V 1568.3199 h 863.2 V 94.720001 Z"
                  clipRule="evenodd"
                  id="path666" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath668">
               <path
                  d="M 240.16,94.720001 V 1568.3199 h 863.2 V 94.720001 Z"
                  transform="translate(-683.20001,-610.40002)"
                  clipRule="evenodd"
                  id="path668" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath1001">
               <path
                  d="M 240.16,94.720001 V 1568.3199 h 863.2 V 94.720001 Z"
                  transform="translate(-329.44,-214.08)"
                  clipRule="evenodd"
                  id="path1001" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath1003">
               <path
                  d="M 240.16,94.720001 V 1568.3199 h 863.2 V 94.720001 Z"
                  clipRule="evenodd"
                  id="path1003" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath1005">
               <path
                  d="M 240.16,94.720001 V 1568.3199 h 863.2 V 94.720001 Z"
                  clipRule="evenodd"
                  id="path1005" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath1007">
               <path
                  d="M 240.16,94.720001 V 1568.3199 h 863.2 V 94.720001 Z"
                  transform="translate(-324.79999,-214.08)"
                  clipRule="evenodd"
                  id="path1007" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath1137">
               <path
                  d="M 240.16,94.720001 V 1568.3199 h 863.2 V 94.720001 Z"
                  transform="translate(-370.88,-688.64001)"
                  clipRule="evenodd"
                  id="path1137" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath1139">
               <path
                  d="M 240.16,94.720001 V 1568.3199 h 863.2 V 94.720001 Z"
                  clipRule="evenodd"
                  id="path1139" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath1141">
               <path
                  d="M 240.16,94.720001 V 1568.3199 h 863.2 V 94.720001 Z"
                  clipRule="evenodd"
                  id="path1141" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath1143">
               <path
                  d="M 240.16,94.720001 V 1568.3199 h 863.2 V 94.720001 Z"
                  transform="translate(-370.88,-693.28003)"
                  clipRule="evenodd"
                  id="path1143" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath1798">
               <path
                  d="M 240.16,94.720001 V 1568.3199 h 863.2 V 94.720001 Z"
                  transform="translate(-770.23999,-1247.84)"
                  clipRule="evenodd"
                  id="path1798" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath1800">
               <path
                  d="M 240.16,94.720001 V 1568.3199 h 863.2 V 94.720001 Z"
                  clipRule="evenodd"
                  id="path1800" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath1802">
               <path
                  d="M 240.16,94.720001 V 1568.3199 h 863.2 V 94.720001 Z"
                  clipRule="evenodd"
                  id="path1802" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath1804">
               <path
                  d="M 240.16,94.720001 V 1568.3199 h 863.2 V 94.720001 Z"
                  transform="translate(-770.23999,-1252.48)"
                  clipRule="evenodd"
                  id="path1804" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath1137-2">
               <path
                  d="M 240.16,94.720001 V 1568.3199 h 863.2 V 94.720001 Z"
                  transform="translate(-370.88,-688.64001)"
                  clipRule="evenodd"
                  id="path1137-0" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath1139-4">
               <path
                  d="M 240.16,94.720001 V 1568.3199 h 863.2 V 94.720001 Z"
                  clipRule="evenodd"
                  id="path1139-7" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath1141-7">
               <path
                  d="M 240.16,94.720001 V 1568.3199 h 863.2 V 94.720001 Z"
                  clipRule="evenodd"
                  id="path1141-4" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath1143-0">
               <path
                  d="M 240.16,94.720001 V 1568.3199 h 863.2 V 94.720001 Z"
                  transform="translate(-370.88,-693.28003)"
                  clipRule="evenodd"
                  id="path1143-0" />
            </clipPath>
            <rect
               x="943.96893"
               y="743.36975"
               width="27.319595"
               height="11.798823"
               id="rect3061-4" />
            <rect
               x="943.96893"
               y="743.36975"
               width="44.039585"
               height="14.295574"
               id="rect3061-4-1" />
            <pattern
               id="EMFhbasepattern"
               patternUnits="userSpaceOnUse"
               width="6"
               height="6"
               x="0"
               y="0" />
            <rect
               x="943.96893"
               y="743.36975"
               width="69.761208"
               height="19.186783"
               id="rect3061-3" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-5" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-5-8" />
            <rect
               x="943.96893"
               y="743.36975"
               width="97.967178"
               height="16.904219"
               id="rect3061-5-5" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-5-8-8" />
            <rect
               x="943.96893"
               y="743.36975"
               width="97.967178"
               height="16.904219"
               id="rect3061-5-5-6" />
            <rect
               x="179.62978"
               y="769.13995"
               width="12.169575"
               height="16.168966"
               id="rect3073-0" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-41" />
            <rect
               x="179.62978"
               y="769.13995"
               width="12.169575"
               height="16.168966"
               id="rect3073-0-1" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54" />
            <rect
               x="179.62978"
               y="769.13995"
               width="12.169575"
               height="16.168966"
               id="rect3073-1" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9" />
            <rect
               x="943.96893"
               y="743.36975"
               width="89.450684"
               height="23.034204"
               id="rect3061-3-4" />
            <rect
               x="179.62978"
               y="769.13995"
               width="12.169575"
               height="16.168966"
               id="rect3073-9" />
            <rect
               x="179.62978"
               y="769.13995"
               width="12.169575"
               height="16.168966"
               id="rect3073-9-7" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-9" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-9-4" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-9" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-9-0" />
            <rect
               x="943.96893"
               y="743.36975"
               width="56.157177"
               height="12.172379"
               id="rect3061-3-4-2" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-5" />
            <rect
               x="943.96893"
               y="743.36975"
               width="39.03614"
               height="39.785801"
               id="rect3061-3-4-2-3" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-41-1" />
            <rect
               x="179.62978"
               y="769.13995"
               width="12.169575"
               height="16.168966"
               id="rect3073-0-1-0" />
            <rect
               x="943.96893"
               y="743.36975"
               width="105.59754"
               height="23.896826"
               id="rect3061-3-4-7" />
            <rect
               x="943.96893"
               y="743.36975"
               width="97.967178"
               height="16.904219"
               id="rect3061-5-5-6-9" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-5-8-8-6" />
            <rect
               x="179.62978"
               y="769.13995"
               width="12.169575"
               height="16.168966"
               id="rect3073-9-7-1" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-9-7" />
            <rect
               x="943.96893"
               y="743.36975"
               width="22.032442"
               height="11.808421"
               id="rect3061-3-4-2-35" />
            <rect
               x="943.96893"
               y="743.36975"
               width="81.624748"
               height="35.751343"
               id="rect3061-3-4-28" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-5-8-8-6-2" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-6" />
            <rect
               x="179.62978"
               y="769.13995"
               width="12.169575"
               height="16.168966"
               id="rect3073-1-5" />
            <rect
               x="179.62978"
               y="769.13995"
               width="12.169575"
               height="16.168966"
               id="rect3073-9-7-1-9" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-9-7-6" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-4" />
            <rect
               x="943.96893"
               y="743.36975"
               width="45.266769"
               height="34.447021"
               id="rect3061-3-4-28-5" />
            <rect
               x="179.62978"
               y="769.13995"
               width="12.169575"
               height="16.168966"
               id="rect3073-9-7-1-9-7" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-9-7-6-1" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-4-1" />
            <rect
               x="943.96893"
               y="743.36975"
               width="83.784931"
               height="13.375142"
               id="rect3061-5-8-8-5" />
            <rect
               x="943.96893"
               y="743.36975"
               width="128.82146"
               height="17.657737"
               id="rect3061-5-5-6-1" />
            <rect
               x="943.96893"
               y="743.36975"
               width="88.836922"
               height="13.969494"
               id="rect3061-5-8-8-5-4" />
            <rect
               x="943.96893"
               y="743.36975"
               width="122.09714"
               height="14.295575"
               id="rect3061-5-5-6-1-9" />
            <rect
               x="943.96893"
               y="743.36975"
               width="52.581455"
               height="11.889262"
               id="rect3061-5-8-8-5-9" />
            <rect
               x="943.96893"
               y="743.36975"
               width="122.09714"
               height="14.295575"
               id="rect3061-5-5-6-1-1" />
            <rect
               x="943.96893"
               y="743.36975"
               width="88.836922"
               height="13.969494"
               id="rect3061-5-8-8-5-9-3" />
            <rect
               x="943.96893"
               y="743.36975"
               width="122.09714"
               height="14.295575"
               id="rect3061-5-5-6-1-1-4" />
            <rect
               x="943.96893"
               y="743.36975"
               width="78.435763"
               height="13.969494"
               id="rect3061-5-8-8-5-3" />
            <rect
               x="943.96893"
               y="743.36975"
               width="135.54579"
               height="18.498278"
               id="rect3061-5-5-6-1-6" />
            <rect
               x="943.96893"
               y="743.36975"
               width="53.175807"
               height="10.997734"
               id="rect3061-5-8-8-5-9-4" />
            <rect
               x="943.96893"
               y="743.36975"
               width="122.09714"
               height="14.295575"
               id="rect3061-5-5-6-1-1-2" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-5-8-8-6-2-2" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-5-8-8-6-2-7" />
            <rect
               x="943.96893"
               y="743.36975"
               width="72.606957"
               height="36.527253"
               id="rect3061-3-4-28-5-9" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-4-1-2" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-5-0" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-4-1-2-3" />
            <rect
               x="179.62978"
               y="769.13995"
               width="12.169575"
               height="16.168966"
               id="rect3073-9-7-1-9-7-7" />
            <rect
               x="943.96893"
               y="743.36975"
               width="24.527861"
               height="14.295574"
               id="rect3061-9-7-6-1-2" />
            <rect
               x="943.96893"
               y="743.36975"
               width="52.854822"
               height="36.814041"
               id="rect3061-3-4-2-3-4" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-6-2" />
            <rect
               x="179.62978"
               y="769.13995"
               width="12.169575"
               height="16.168966"
               id="rect3073-1-5-0" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-5-8-8-6-2-2-2" />
            <rect
               x="943.96893"
               y="743.36975"
               width="45.266769"
               height="34.447021"
               id="rect3061-3-4-28-5-9-1" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-5-0-4" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-5-0-4-9" />
            <rect
               x="179.62978"
               y="769.13995"
               width="12.169575"
               height="16.168966"
               id="rect3073-00" />
            <rect
               x="179.62978"
               y="769.13995"
               width="12.169575"
               height="16.168966"
               id="rect3073-9-7-1-9-7-5" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-9-7-6-1-5" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-5-0-4-6" />
            <rect
               x="943.96893"
               y="743.36975"
               width="31.611519"
               height="38.01804"
               id="rect3061-3-4-2-3-4-3" />
            <rect
               x="943.96893"
               y="743.36975"
               width="29.174789"
               height="12.290115"
               id="rect3061-5-8-8-5-9-4-1" />
            <rect
               x="943.96893"
               y="743.36975"
               width="133.86471"
               height="18.498278"
               id="rect3061-5-5-6-1-1-2-1" />
            <rect
               x="943.96893"
               y="743.36975"
               width="29.174789"
               height="12.290115"
               id="rect3061-5-8-8-5-9-4-1-7" />
            <rect
               x="943.96893"
               y="743.36975"
               width="122.09714"
               height="14.295575"
               id="rect3061-5-5-6-1-1-2-1-9" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-5-0-4-6-8" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-5-0-4-6-1" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-5-0-4-6-82" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-5-0-4-6-17" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-5-0-4-6-3" />
            <rect
               x="943.96893"
               y="743.36975"
               width="29.174789"
               height="12.290115"
               id="rect3061-5-8-8-5-9-4-1-7-0" />
            <rect
               x="943.96893"
               y="743.36975"
               width="82.869913"
               height="15.484279"
               id="rect3061-5-5-6-1-1-2-1-9-5" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-5-0-4-9-8" />
            <rect
               x="179.62978"
               y="769.13995"
               width="12.169575"
               height="16.168966"
               id="rect3073-00-4" />
            <rect
               x="179.62978"
               y="769.13995"
               width="12.169575"
               height="16.168966"
               id="rect3073-9-7-1-9-7-9" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-9-7-6-1-0" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-5-0-6" />
            <rect
               x="943.96893"
               y="743.36975"
               width="41.977569"
               height="45.176255"
               id="rect3061-3-4-2-3-4-3-0" />
            <rect
               x="179.62978"
               y="769.13995"
               width="12.169575"
               height="16.168966"
               id="rect3073-9-7-1-9-7-0" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-9-7-6-1-21" />
            <rect
               x="179.62978"
               y="769.13995"
               width="12.169575"
               height="16.168966"
               id="rect3073-9-7-1-9-7-9-6" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-9-7-6-1-0-8" />
            <rect
               x="179.62978"
               y="769.13995"
               width="12.169575"
               height="16.168966"
               id="rect3073-9-7-1-9-7-9-4" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-9-7-6-1-0-2" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-4-1-2-3-1" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-4-1-2-3-8" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-4-1-2-3-0" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-4-1-2-3-6" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-4-1-6" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-4-1-0" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-4-1-2-3-0-8" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-2-4-4-7" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-3" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-7" />
            <rect
               x="943.96893"
               y="743.36975"
               width="28.475859"
               height="11.182828"
               id="rect3061-54-9-0" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-5-8-8-6-2-7-7" />
            <rect
               x="943.96893"
               y="743.36975"
               width="60.791729"
               height="11.54965"
               id="rect3061-5-8-8-5-9-4-1-0" />
            <rect
               x="943.96893"
               y="743.36975"
               width="122.09714"
               height="14.295575"
               id="rect3061-5-5-6-1-1-2-1-7" />
            <rect
               x="943.96893"
               y="743.36975"
               width="50.57614"
               height="12.07998"
               id="rect3061-5-8-8-5-9-4-1-9" />
            <rect
               x="943.96893"
               y="743.36975"
               width="122.09714"
               height="14.295575"
               id="rect3061-5-5-6-1-1-2-1-8" />
            <rect
               x="943.96893"
               y="743.36975"
               width="113.98945"
               height="12.208644"
               id="rect3061-3-4-2-3-4-3-0-9" />
            <rect
               x="943.96893"
               y="743.36975"
               width="41.511013"
               height="24.936565"
               id="rect3061-3-4-2-3-4-3-0-4" />
            <rect
               x="943.96893"
               y="743.36975"
               width="106.91838"
               height="14.329965"
               id="rect3061-3-4-2-3-4-3-0-5" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-9-7-6-1-0-28" />
            <rect
               x="943.96893"
               y="743.36975"
               width="61.50238"
               height="12.527807"
               id="rect3061-9-7-6-1-0-28-8" />
            <rect
               x="943.96893"
               y="743.36975"
               width="107.83546"
               height="25.509077"
               id="rect3061-3-4-3" />
            <rect
               x="943.96893"
               y="743.36975"
               width="30.957703"
               height="11.545574"
               id="rect3061-9-7-6-3" />
            <rect
               x="943.96893"
               y="743.36975"
               width="30.957703"
               height="11.545574"
               id="rect3061-9-7-6-3-7" />
            <rect
               x="943.96893"
               y="743.36975"
               width="128.82146"
               height="17.657738"
               id="rect3061-5-5-6-1-4" />
            <rect
               x="943.96893"
               y="743.36975"
               width="128.82146"
               height="17.657738"
               id="rect3061-5-5-6-1-4-1" />
            <rect
               x="943.96893"
               y="743.36975"
               width="135.54579"
               height="18.498278"
               id="rect3061-5-5-6-1-6-6" />
            <rect
               x="943.96893"
               y="743.36975"
               width="135.54579"
               height="18.498278"
               id="rect3061-5-5-6-1-6-6-1" />
            <rect
               x="943.96893"
               y="743.36975"
               width="122.09714"
               height="14.295575"
               id="rect3061-5-5-6-1-1-8" />
            <rect
               x="943.96893"
               y="743.36975"
               width="122.09714"
               height="14.295575"
               id="rect3061-5-5-6-1-1-8-3" />
            <rect
               x="943.96893"
               y="743.36975"
               width="97.967178"
               height="16.904219"
               id="rect3061-5-5-6-3" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-5-8-8-6-2-2-5" />
            <rect
               x="943.96893"
               y="743.36975"
               width="97.967178"
               height="16.904219"
               id="rect3061-5-5-6-3-5" />
            <rect
               x="943.96893"
               y="743.36975"
               width="97.967178"
               height="16.904219"
               id="rect3061-5-5-6-3-3" />
            <rect
               x="943.96893"
               y="743.36975"
               width="97.967178"
               height="16.904219"
               id="rect3061-5-5-6-3-6" />
            <rect
               x="943.96893"
               y="743.36975"
               width="97.967178"
               height="16.904219"
               id="rect3061-5-5-6-3-7" />
            <rect
               x="943.96893"
               y="743.36975"
               width="97.967178"
               height="16.904219"
               id="rect3061-5-5-6-3-7-9" />
            <rect
               x="943.96893"
               y="743.36975"
               width="97.967178"
               height="16.904219"
               id="rect3061-5-5-6-3-5-1" />
            <pattern
               id="EMFhbasepattern-3"
               patternUnits="userSpaceOnUse"
               width="6"
               height="6"
               x="0"
               y="0" />
            <rect
               x="943.96893"
               y="743.36975"
               width="97.967178"
               height="16.904219"
               id="rect3061-5-5-6-3-8" />
            <rect
               x="943.96893"
               y="743.36975"
               width="97.967178"
               height="16.904219"
               id="rect3061-5-5-6-3-8-8" />
            <rect
               x="943.96893"
               y="743.36975"
               width="61.50238"
               height="12.527807"
               id="rect3061-9-7-6-1-0-28-8-4" />
            <rect
               x="943.96893"
               y="743.36975"
               width="39.03614"
               height="39.785801"
               id="rect3061-3-4-2-3-4-9" />
            <rect
               x="943.96893"
               y="743.36975"
               width="113.98945"
               height="12.208644"
               id="rect3061-3-4-2-3-4-3-0-9-6" />
            <rect
               x="943.96893"
               y="743.36975"
               width="113.98945"
               height="12.208644"
               id="rect3061-3-4-2-3-4-3-0-9-4" />
            <rect
               x="943.96893"
               y="743.36975"
               width="129.53945"
               height="16.411347"
               id="rect3061-3-4-2-3-4-3-0-9-7" />
            <rect
               x="943.96893"
               y="743.36975"
               width="41.97757"
               height="45.176254"
               id="rect3061-3-4-2-3-4-3-0-8" />
            <rect
               x="943.96893"
               y="743.36975"
               width="76.439732"
               height="65.769497"
               id="rect3061-3-4-2-3-4-3-0-41" />
            <rect
               x="943.96893"
               y="743.36975"
               width="105.59754"
               height="33.432068"
               id="rect3061-3-4-7-6" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-5-8-8-6-6" />
            <rect
               x="943.96893"
               y="743.36975"
               width="97.967178"
               height="16.904219"
               id="rect3061-5-5-6-3-7-9-0" />
            <rect
               x="943.96893"
               y="743.36975"
               width="27.207703"
               height="14.295574"
               id="rect3061-9-7-6-9" />
            <rect
               x="179.62978"
               y="769.13995"
               width="12.169575"
               height="16.168966"
               id="rect3073-9-7-1-9-9" />
            <rect
               x="943.96893"
               y="743.36975"
               width="36.796786"
               height="107.61643"
               id="rect3061-54-9-2-4-4-1-2-3-0-8-1" />
         </defs>

         <g
            id="g1">
            <path
               style={{
                  fill: '#ffffff',
                  fillOpacity: 1,
                  stroke: '#000000',
                  strokeWidth: 0.496,
                  strokeDasharray: '2.976, 2.976',
                  strokeDashoffset: 0
               }}
               d="m 534.91672,469.53801 56.76061,-0.29718 0.59435,68.0533 h 10.10398"
               id="b01_line_out" />
            <path
               style={{
                  fill: '#ffffff',
                  fillOpacity: 1,
                  stroke: '#000000',
                  strokeWidth: 0.496,
                  strokeDasharray: '2.976, 2.976',
                  strokeDashoffset: 0
               }}
               d="m 672.01215,537.94594 6.09392,-0.21014 -0.21013,-52.53378 72.28648,-0.21013 -0.21013,-36.35338 30.88986,0.21013 0.21014,36.14325 130.07365,0.21013 v -38.66486 l 28.78851,-10e-6"
               id="b02_line_out" />
            <g
               id="grp_T08">
               <path
                  id="t08_body"
                  d="m 355.45629,799.80984 v 108.32 H 195.6163 v -108.32 z"
                  style={{
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }}
                  className={clst08_body}
                  fill="url(#tk08fill)" />
               <text
                  id="t08_label"
                  style={{
                     fontStyle: 'normal',
                     fontVariant: 'normal',
                     fontWeight: 'normal',
                     fontStretch: 'normal',
                     fontSize: '9.33333px',
                     fontFamily: 'sans-serif',
                     fontVariantLigatures: 'normal',
                     fontVariantCaps: 'normal',
                     fontVariantNumeric: 'normal',
                     fontVariantEastAsian: 'normal',
                     textAlign: 'center',
                     whiteSpace: 'pre',
                     shapeInside: 'url(#rect3061-3-4-3)',
                     display: 'inline',
                     fill: '#000000',
                     fillOpacity: 1,
                     stroke: '#000405',
                     strokeWidth: 0.56,
                     strokeDasharray: 'none'
                  }}
                  transform="translate(-726.56923,168.11743)"
                  className={clspagetext}
                  x="178.39056"
                  y="0"><tspan
                     x="955.50406"
                     y="751.86131"
                     id="tspan200">Treated Water Tank
                  </tspan><tspan
                     x="988.63739"
                     y="763.52799"
                     id="tspan201">T-08</tspan></text>
            </g>
            <path
               id="p01_line_out_1"
               d="M 209.05555,498.60283 V 315.68843"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.500418,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clsp01_line_out_1} />
            <path
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.492778,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 283.85356,315.82954 -74.64112,-0.0639"
               id="p01_line_out_2"
               className={clsp01_line_out_2} />
            <path
               id="p02_line_out"
               d="M 284.02458,498.44449 V 315.83497"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clsp02_line_out} />
            <g
               id="waste_water"
               transform="rotate(-90,532.01253,606.97326)">
               <path
                  id="waste_water_body"
                  d="m 812.95474,134.48819 v 68.32 l -12.95996,13.28 -13.28002,-13.28 v -68.32 z"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }}
                  className={waste_water_body} />
            </g>
            <path
               id="cds_body"
               d="m 565.37627,203.08985 v 55.36005 h 44 v -55.36005 z"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clscds_body} />
            <path
               id="path799"
               d="m 593.26393,214.56459 v -5.95313 h 0.78125 v 2.45313 h 3.09375 v -2.45313 h 0.78125 v 5.95313 h -0.78125 v -2.79688 h -3.09375 v 2.79688 z m 5.84375,0 v -5.95313 h 0.78125 v 5.25 h 2.9375 v 0.70313 z m 0,0"
               style={{
                  fill: '#000000',
                  fillOpacity: 1,
                  fillRule: 'nonzero',
                  stroke: 'none',
                  strokeWidth: 0.025391
               }}
               aria-label="HL" />
            <path
               id="path800"
               d="m 594.79723,254.11347 v -5.95312 h 0.78125 v 5.25 h 2.9375 v 0.70312 z m 4.66015,0 v -5.95312 h 0.78125 v 5.25 h 2.9375 v 0.70312 z m 0,0"
               style={{
                  fill: '#000000',
                  fillOpacity: 1,
                  fillRule: 'nonzero',
                  stroke: 'none',
                  strokeWidth: 0.025391
               }}
               aria-label="LL" />
            <path
               id="p03_line_in"
               d="M 604.33281,253.66856 V 193.61262"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clsline} />
            <path
               id="t05_line_out"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.496,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 1006.3211,560.13881 h 17.8787 m -17.9179,-27.45548 v 27.37259"
               className={clshv06_line_in} />
            <path
               id="mv02_line_out"
               d="m 1110.7811,563.40331 v 30.83237 m 0,-0.71701 v 28.0946"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.431069,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clsmv02_line_out} />
            <path
               id="mv02_line_in"
               d="m 1110.8016,475.33686 v 32.39754 m 0,-0.75343 v 29.52079"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clsmv02_line_in} />
            <path
               id="p11_line_out"
               d="m 222.01629,862.52984 v -82.08 H 206.9763"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={p11_line_out} />
            <path
               id="t05_body"
               d="m 969.69627,451.80988 v 80.96003 h 44.16003 v -80.96003 z"
               style={{
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clst05_body}
               fill="url(#tk05fill)" />
            <path
               id="path1030"
               d="m 999.44552,528.2051 v -5.95312 h 0.78128 v 5.25 h 2.9375 v 0.70312 z m 4.66018,0 v -5.95312 h 0.7812 v 5.25 h 2.9375 v 0.70312 z m 0,0"
               style={{
                  fill: '#000000',
                  fillOpacity: 1,
                  fillRule: 'nonzero',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               aria-label="LL" />
            <path
               id="hv04_line_in"
               d="m 925.5363,506.36988 v 3.84003 h 9.12"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clshv04_line_in} />
            <path
               id="hv04_line_out"
               d="m 960.96717,510.20991 h 8.75352"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clshv04_line_out} />
            <path
               id="screening_body"
               d="m 363.9363,296.60987 v 37.76001 h 75.67999 v -37.76001 z"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clsscreening_body} />
            <path
               id="t06_body"
               d="m 1150.0164,399.3299 v 80.95997 h 44 V 399.3299 Z"
               style={{
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clst06_body}
               fill="url(#tk06fill)" />
            <path
               id="t06_line_in"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 1155.6163,352.12989 v 69.91999 m -11.8401,-69.91999 h 11.8401"
               className={clst06_line_in} />
            <path
               id="mv03_filtering_line_in"
               d="m 1224.8655,468.92988 h -30.8519"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clsmv03_filtering_line_in} />
            <path
               id="path1602"
               d="m 1177.0434,477.56269 v -5.95312 h 0.7812 v 5.25 h 2.9375 v 0.70312 z m 4.6601,0 v -5.95312 h 0.7813 v 5.25 h 2.9375 v 0.70312 z m 0,0"
               style={{
                  fill: '#000000',
                  fillOpacity: 1,
                  fillRule: 'nonzero',
                  stroke: 'none',
                  strokeWidth: 0.025391
               }}
               aria-label="LL" />
            <path
               id="path1604"
               d="m 1175.1878,417.71894 v -5.95312 h 0.7813 v 2.45312 h 3.0937 v -2.45312 h 0.7813 v 5.95312 h -0.7813 v -2.79687 h -3.0937 v 2.79687 z m 5.8438,0 v -5.95312 h 0.7812 v 5.25 h 2.9375 v 0.70312 z m 0,0"
               style={{
                  fill: '#000000',
                  fillOpacity: 1,
                  fillRule: 'nonzero',
                  stroke: 'none',
                  strokeWidth: 0.025391
               }}
               aria-label="HL" />
            <path
               id="p05_line_out"
               d="M 704.26224,580.14082 H 394.33032 V 328.91426"
               style={{
                  fill: 'none',
                  stroke: '#020508',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clsp05_line_out} />
            <path
               id="path1786"
               d="m 646.79333,808.28144 v -5.9531 h 0.78125 v 5.25 h 2.9375 v 0.7031 z m 4.66015,0 v -5.9531 h 0.78125 v 5.25 h 2.9375 v 0.7031 z m 0,0"
               style={{
                  fill: '#000000',
                  fillOpacity: 1,
                  fillRule: 'nonzero',
                  stroke: 'none',
                  strokeWidth: 0.025391
               }}
               aria-label="LL" />
            <path
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 464.2563,889.24984 v 13.6"
               id="hv18_line_in"
               className={clshv18_line_in} />
            <path
               id="p10_line_in"
               d="m 464.0963,848.56334 v 14.4312"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.515053,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clsp10_line_in} />
            <path
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.49803,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 751.11479,868.28984 h 64.08539"
               id="p07_line_out"
               className={clsp07_line_out} />
            <path
               id="hv09_line_in"
               d="m 1303.6952,600.41974 -0.1532,10.98231"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.506757,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clshv09_line_in} />
            <path
               id="t08_line_out"
               d="M 389.5363,903.00984 H 355.45629"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clst08_line_out} />
            <path
               id="path1604-9-9"
               d="m 567.81015,368.30877 v -5.95312 h 0.7813 v 2.45312 h 3.0937 v -2.45312 h 0.7813 v 5.95312 h -0.7813 v -2.79687 h -3.0937 v 2.79687 z m 5.8438,0 v -5.95312 h 0.7812 v 5.25 h 2.9375 v 0.70312 z m 0,0"
               style={{
                  fill: '#000000',
                  fillOpacity: 1,
                  fillRule: 'nonzero',
                  stroke: 'none',
                  strokeWidth: 0.025391
               }}
               aria-label="HL" />
            <g
               id="g_t03_body">
               <path
                  id="t03_body"
                  d="m 671.87826,452.26231 v 37.24065 h 265.36127 v -37.24065 z"
                  style={{
                     strokeWidth: 0.616019,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }}
                  className={clst03_body}
                  fill="url(#tk03fill)"
                  stroke="url(#tk03fill)" />
            </g>
            <g
               id="t03_tank_edge"
               transform="rotate(-90,297.21268,262.64256)">
               <path
                  id="path470-9-9"
                  d="m 70.05005,719.88995 v -82.87994 h 37.59998"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
               <path
                  id="path471-7-0"
                  d="M 107.65003,902.92999 H 70.05005"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
               <path
                  id="t03_bottom_1"
                  d="m 70.05005,719.88995 -16.96002,11.84003 16.96002,11.84003"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }}
                  className={clst03_bottom_1} />
               <path
                  id="t03_bottom_2"
                  d="m 70.05005,879.08996 -16.96002,11.84003 16.96002,12"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }}
                  className={clst03_bottom_2} />
               <path
                  id="path558-7-8"
                  d="m 70.05005,879.08996 v -135.52 m 2.4,135.52 h 34.88 m -37.28,-135.52 h 37.28 m -34.88,-23.68 h 34.88"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
            </g>
            <g
               id="t03_rollers"
               transform="rotate(-90,297.21268,262.64256)">
               <path
                  id="path498-2-4"
                  d="m 79.13001,649.33526 -2.88001,2.23999 2.88001,2.08002"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
               <path
                  id="path499-0-1"
                  d="m 79.13001,665.3474 -2.88001,2.08002 2.88001,2.08002"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
               <path
                  id="path500-8-0"
                  d="m 79.13001,682.05529 -2.88001,2.07996 2.88001,2.24005"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
               <path
                  id="path501-1-8"
                  d="m 78.96697,697.12357 -2.88001,2.08002 2.88001,2.08002"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
               <path
                  id="path550-0-4"
                  d="m 79.13001,758.05529 -2.88001,2.23999 2.88001,2.08002"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
               <path
                  id="path551-6-4"
                  d="m 79.13001,773.41527 -2.88001,2.08002 2.88001,2.07996"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
               <path
                  id="path552-6-3"
                  d="m 79.13001,788.77526 -2.88001,2.08002 2.88001,2.23999"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
               <path
                  id="path553-0-5"
                  d="m 79.13001,804.45525 -2.88001,2.23999 2.88001,2.08002"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
               <path
                  id="path554-6-0"
                  d="m 79.13001,818.53527 -2.88001,2.08002 2.88001,2.07995"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
               <path
                  id="path555-1-3"
                  d="m 79.13001,831.73528 -2.88001,2.08002 2.88001,2.07995"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
               <path
                  id="path556-4-0"
                  d="m 79.13001,847.09527 -2.88001,2.23999 2.88001,2.08001"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
               <path
                  id="path557-1-5"
                  d="m 79.13001,862.93529 -2.88001,2.07996 2.88001,2.08002"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
               <g
                  id="g-roller_1"
                  transform="translate(-585.83589,-24.008345)">
                  <path
                     id="roller_1_1"
                     d="m 679.05925,677.53489 3.04,-5.28 m -3.04,5.28 5.12,-3.04 m -5.12,3.04 h 6.08 m -6.08,0 5.12,3.04 m -5.12,-3.04 3.04,5.28 m -3.04,-5.28 v 6.08 m 0,-6.08 -3.04,5.28 m 3.04,-5.28 -5.28,3.04 m 5.28,-3.04 h -6.24 m 6.24,0 -5.28,-3.04 m 5.28,3.04 -3.04,-5.28 m 3.04,5.28 v -6.24"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeLinecap: 'butt',
                        strokeLinejoin: 'miter',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1,
                        transformOrigin: '679.05925px 677.53489px'
                     }}
                     className="star star1" />
                  <path
                     id="roller_1_2"
                     d="m 679.35407,693.09126 3.04,-5.28 m -3.04,5.28 5.12,-3.04 m -5.12,3.04 h 6.08 m -6.08,0 5.12,3.04 m -5.12,-3.04 3.04,5.28 m -3.04,-5.28 v 6.08 m 0,-6.08 -3.04,5.28 m 3.04,-5.28 -5.28,3.04 m 5.28,-3.04 h -6.24 m 6.24,0 -5.28,-3.04 m 5.28,3.04 -3.04,-5.28 m 3.04,5.28 v -6.24"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeLinecap: 'butt',
                        strokeLinejoin: 'miter',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1,
                        transformOrigin: '679.35407px 693.09126px'
                     }}
                     className="star star2" />
                  <path
                     id="roller_1_3"
                     d="m 679.35407,708.86244 3.04,-5.28 m -3.04,5.28 5.12,-3.04 m -5.12,3.04 h 6.08 m -6.08,0 5.12,3.04 m -5.12,-3.04 3.04,5.28 m -3.04,-5.28 v 6.08 m 0,-6.08 -3.04,5.28 m 3.04,-5.28 -5.28,3.04 m 5.28,-3.04 h -6.24 m 6.24,0 -5.28,-3.04 m 5.28,3.04 -3.04,-5.28 m 3.04,5.28 v -6.24"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeLinecap: 'butt',
                        strokeLinejoin: 'miter',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1,
                        transformOrigin: '679.35407px 708.86244px'
                     }}
                     className="star star3" />
                  <path
                     id="roller_1_4"
                     d="m 679.33322,723.60538 3.04,-5.28 m -3.04,5.28 5.12,-3.04 m -5.12,3.04 h 6.08 m -6.08,0 5.12,3.04 m -5.12,-3.04 3.04,5.28 m -3.04,-5.28 v 6.08 m 0,-6.08 -3.04,5.28 m 3.04,-5.28 -5.28,3.04 m 5.28,-3.04 h -6.24 m 6.24,0 -5.28,-3.04 m 5.28,3.04 -3.04,-5.28 m 3.04,5.28 v -6.24"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeLinecap: 'butt',
                        strokeLinejoin: 'miter',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1,
                        transformOrigin: '679.33322px 723.60538px'
                     }}
                     className="star star4" />
               </g>
               <g
                  id="g3053-7-9"
                  transform="translate(-585.27076,-22.96836)">
                  <path
                     id="roller_2_1"
                     d="m 678.38329,783.63824 3.04,-5.28 m -3.04,5.28 5.12,-3.04 m -5.12,3.04 h 6.08 m -6.08,0 5.12,3.04 m -5.12,-3.04 3.04,5.28 m -3.04,-5.28 v 6.08 m 0,-6.08 -3.04,5.28 m 3.04,-5.28 -5.28,3.04 m 5.28,-3.04 h -6.24 m 6.24,0 -5.28,-3.04 m 5.28,3.04 -3.04,-5.28 m 3.04,5.28 v -6.24"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeLinecap: 'butt',
                        strokeLinejoin: 'miter',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1,
                        transformOrigin: '678.38329px 783.63824px'
                     }}
                     className="star star5" />
                  <path
                     id="roller_2_2"
                     d="m 678.78894,798.79421 3.04,-5.28 m -3.04,5.28 5.12,-3.04 m -5.12,3.04 h 6.08 m -6.08,0 5.12,3.04 m -5.12,-3.04 3.04,5.28 m -3.04,-5.28 v 6.08 m 0,-6.08 -3.04,5.28 m 3.04,-5.28 -5.28,3.04 m 5.28,-3.04 h -6.24 m 6.24,0 -5.28,-3.04 m 5.28,3.04 -3.04,-5.28 m 3.04,5.28 v -6.24"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeLinecap: 'butt',
                        strokeLinejoin: 'miter',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1,
                        transformOrigin: '678.78894px 798.79421px'
                     }}
                     className="star star6" />
                  <path
                     id="roller_2_3"
                     d="m 678.97764,813.74671 3.04,-5.28 m -3.04,5.28 5.12,-3.04 m -5.12,3.04 h 6.08 m -6.08,0 5.12,3.04 m -5.12,-3.04 3.04,5.28 m -3.04,-5.28 v 6.08 m 0,-6.08 -3.04,5.28 m 3.04,-5.28 -5.28,3.04 m 5.28,-3.04 h -6.24 m 6.24,0 -5.28,-3.04 m 5.28,3.04 -3.04,-5.28 m 3.04,5.28 v -6.24"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeLinecap: 'butt',
                        strokeLinejoin: 'miter',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1,
                        transformOrigin: '678.97764px 813.7467px'
                     }}
                     className="star star7" />
                  <path
                     id="roller_2_4"
                     d="m 678.97315,828.86257 3.04,-5.28 m -3.04,5.28 5.12,-3.04 m -5.12,3.04 h 6.08 m -6.08,0 5.12,3.04 m -5.12,-3.04 3.04,5.28 m -3.04,-5.28 v 6.08 m 0,-6.08 -3.04,5.28 m 3.04,-5.28 -5.28,3.04 m 5.28,-3.04 h -6.24 m 6.24,0 -5.28,-3.04 m 5.28,3.04 -3.04,-5.28 m 3.04,5.28 v -6.24"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeLinecap: 'butt',
                        strokeLinejoin: 'miter',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1,
                        transformOrigin: '678.97315px 828.86257px'
                     }}
                     className="star star8" />
                  <path
                     id="roller_2_5"
                     d="m 679.046,844.01116 3.04,-5.28 m -3.04,5.28 5.12,-3.04 m -5.12,3.04 h 6.08 m -6.08,0 5.12,3.04 m -5.12,-3.04 3.04,5.28 m -3.04,-5.28 v 6.08 m 0,-6.08 -3.04,5.28 m 3.04,-5.28 -5.28,3.04 m 5.28,-3.04 h -6.24 m 6.24,0 -5.28,-3.04 m 5.28,3.04 -3.04,-5.28 m 3.04,5.28 v -6.24"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeLinecap: 'butt',
                        strokeLinejoin: 'miter',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1,
                        transformOrigin: '679.046px 844.01116px'
                     }}
                     className="star star9" />
                  <path
                     id="roller_2_6"
                     d="m 679.12623,858.78683 3.04,-5.28 m -3.04,5.28 5.12,-3.04 m -5.12,3.04 h 6.08 m -6.08,0 5.12,3.04 m -5.12,-3.04 3.04,5.28 m -3.04,-5.28 v 6.08 m 0,-6.08 -3.04,5.28 m 3.04,-5.28 -5.28,3.04 m 5.28,-3.04 h -6.24 m 6.24,0 -5.28,-3.04 m 5.28,3.04 -3.04,-5.28 m 3.04,5.28 v -6.24"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeLinecap: 'butt',
                        strokeLinejoin: 'miter',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1,
                        transformOrigin: '679.12623px 858.78683px'
                     }}
                     className="star star10" />
                  <path
                     id="roller_2_7"
                     d="m 679.13811,873.45692 3.04,-5.28 m -3.04,5.28 5.12,-3.04 m -5.12,3.04 h 6.08 m -6.08,0 5.12,3.04 m -5.12,-3.04 3.04,5.28 m -3.04,-5.28 v 6.08 m 0,-6.08 -3.04,5.28 m 3.04,-5.28 -5.28,3.04 m 5.28,-3.04 h -6.24 m 6.24,0 -5.28,-3.04 m 5.28,3.04 -3.04,-5.28 m 3.04,5.28 v -6.24"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeLinecap: 'butt',
                        strokeLinejoin: 'miter',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1,
                        transformOrigin: '679.13811px 873.45692px'
                     }}
                     className="star star11" />
                  <path
                     id="roller_2_8"
                     d="m 679.00587,888.19986 3.04,-5.28 m -3.04,5.28 5.12,-3.04 m -5.12,3.04 h 6.08 m -6.08,0 5.12,3.04 m -5.12,-3.04 3.04,5.28 m -3.04,-5.28 v 6.08 m 0,-6.08 -3.04,5.28 m 3.04,-5.28 -5.28,3.04 m 5.28,-3.04 h -6.24 m 6.24,0 -5.28,-3.04 m 5.28,3.04 -3.04,-5.28 m 3.04,5.28 v -6.24"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeLinecap: 'butt',
                        strokeLinejoin: 'miter',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1,
                        transformOrigin: '679.00587px 888.19986px'
                     }}
                     className="star star12" />
               </g>
            </g>
            <path
               id="waste_water_out"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1,
                  markerEnd: 'url(#Triangle)'
               }}
               d="m 156.77301,338.97393 h -15.4698 m 15.60714,0.025 v 143.0421"
               className={clswaste_water_out} />
            <text
               id="waste_water_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-3)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-878.1459,-409.41053)"
               className={clspagetext}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan202">Waste Water</tspan></text>
            <path
               id="ft01_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 300.06978,315.60809 -0.082,-50.70501 m -16.3311,-16.70334 h 32.79529 m -16.18009,-16.59607 a 16.597471,16.51177 0 0 1 16.59749,16.51177 16.597471,16.51177 0 0 1 -16.59749,16.51177 16.597471,16.51177 0 0 1 -16.5975,-16.51177 16.597471,16.51177 0 0 1 16.5975,-16.51177 z"
               className={clsft01_body} />
            <text
               id="ft01_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-8-8)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-653.92132,-506.84622)"><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan203">FT01</tspan></text>
            <text
               id="ft01_value"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-5-6)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-644.65173,-524.89612)"
               className={clsshowsensor}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan204">{ft01_1}</tspan></text>
            <g
               id="g181"
               transform="translate(-33.580883,-10.698334)">
               <g
                  id="g183">
                  <path
                     id="b01_body"
                     style={{
                        fill: '#ffffff',
                        stroke: '#000405',
                        strokeWidth: 0.586022
                     }}
                     d="m 654.86844,543.8914 a 12.524436,12.293862 0 0 0 -12.52444,12.29386 12.524436,12.293862 0 0 0 12.52444,12.29386 12.524436,12.293862 0 0 0 12.52444,-12.29386 12.524436,12.293862 0 0 0 -12.52444,-12.29386 z m -0.35921,-0.10559 h -18.56 v 9.76002 l 6.39996,0.15997 m 4.32001,12.16003 -4.79999,7.35999 h 25.44001 l -4.79999,-7.35999"
                     className={clsb01_body} />
                  <text
                     id="b01_label"
                     style={{
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        fontWeight: 'normal',
                        fontStretch: 'normal',
                        fontSize: '9.33333px',
                        fontFamily: 'sans-serif',
                        fontVariantLigatures: 'normal',
                        fontVariantCaps: 'normal',
                        fontVariantNumeric: 'normal',
                        fontVariantEastAsian: 'normal',
                        whiteSpace: 'pre',
                        shapeInside: 'url(#rect3061-41-1)',
                        display: 'inline',
                        fill: '#000000',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     transform="translate(-298.63155,-192.14535)"
                     className={clslabeltext}><tspan
                        x="943.96875"
                        y="751.86131"
                        id="tspan205">B-01</tspan></text>
               </g>
               <g
                  id="g182">
                  <g
                     id="g3074-3-6"
                     transform="rotate(-90,293.25168,432.00521)">
                     <path
                        id="path1144-1-6-0"
                        d="m 191.37561,793.45873 h -9.44"
                        style={{
                           fill: 'none',
                           stroke: '#000000',
                           strokeWidth: 0.5,
                           strokeLinecap: 'round',
                           strokeLinejoin: 'round',
                           strokeMiterlimit: 10,
                           strokeDasharray: 'none',
                           strokeOpacity: 1
                        }} />
                     <ellipse
                        style={{
                           fill: '#ffffff',
                           fillOpacity: 1,
                           stroke: '#000405',
                           strokeWidth: 0.56,
                           strokeDasharray: 'none'
                        }}
                        id="path3073-4-5"
                        cx="197.28423"
                        cy="793.45056"
                        rx="6.0562205"
                        ry="6.1990557" />
                     <text
                        id="text3073-1-7"
                        style={{
                           fontStyle: 'normal',
                           fontVariant: 'normal',
                           fontWeight: 'normal',
                           fontStretch: 'normal',
                           fontSize: '9.33333px',
                           fontFamily: 'Calibri',
                           whiteSpace: 'pre',
                           shapeInside: 'url(#rect3073-0-1-0)',
                           display: 'inline',
                           fill: '#009900',
                           fillOpacity: 1,
                           stroke: '#000405',
                           strokeWidth: 0.56,
                           strokeDasharray: 'none'
                        }}
                        transform="rotate(90,180.90494,790.79846)"><tspan
                           x="179.62891"
                           y="777.30729"
                           id="tspan207"><tspan
                              style={{
                                 fill: '#000000'
                              }}
                              id="tspan206">M</tspan></tspan></text>
                  </g>
               </g>
            </g>
            <g
               id="grp_B02"
               transform="rotate(-90,668.79268,703.2482)">
               <path
                  id="b02_body"
                  style={{
                     fill: '#ffffff',
                     stroke: '#000405',
                     strokeWidth: 0.586022
                  }}
                  d="m 838.9296,687.13855 a 12.293862,12.524436 0 0 1 -12.29386,12.52444 12.293862,12.524436 0 0 1 -12.29386,-12.52444 12.293862,12.524436 0 0 1 12.29386,-12.52444 12.293862,12.524436 0 0 1 12.29386,12.52444 z m 0.10559,0.35921 v 18.56 h -9.76002 l -0.15997,-6.39996 m -12.16003,-4.32001 -7.35999,4.79999 v -25.44001 l 7.35999,4.79999"
                  className={clsb02_body} />
               <text
                  id="b02_label"
                  style={{
                     fontSize: '9.33333px',
                     whiteSpace: 'pre',
                     shapeInside: 'url(#rect3061)',
                     display: 'inline',
                     fill: '#000000',
                     fillOpacity: 1,
                     stroke: '#000405',
                     strokeWidth: 0.56,
                     strokeDasharray: 'none'
                  }}
                  transform="rotate(90,920.81948,655.14019)"
                  className={clslabeltext}><tspan
                     x="943.96875"
                     y="751.86131"
                     id="tspan209"><tspan
                        style={{
                           fontFamily: 'Calibri'
                        }}
                        id="tspan208">B-02</tspan></tspan></text>
               <g
                  id="g3074-3"
                  transform="translate(656.98831,-106.53664)">
                  <path
                     id="path1144-1-6"
                     d="m 191.37561,793.45873 h -9.44"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     id="path3073-4"
                     cx="197.28423"
                     cy="793.45056"
                     rx="6.0562205"
                     ry="6.1990557" />
                  <text
                     id="text3073-1"
                     style={{
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        fontWeight: 'normal',
                        fontStretch: 'normal',
                        fontSize: '9.33333px',
                        fontFamily: 'Calibri',
                        whiteSpace: 'pre',
                        shapeInside: 'url(#rect3073-0)',
                        display: 'inline',
                        fill: '#009900',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     transform="rotate(90,180.90494,790.79846)"><tspan
                        x="179.62891"
                        y="777.30729"
                        id="tspan211"><tspan
                           style={{
                              fill: '#000000'
                           }}
                           id="tspan210">M</tspan></tspan></text>
               </g>
            </g>
            <text
               id="fcv01_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-624.39676,-419.65809)"><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan212">FCV-01</tspan></text>
            <g
               id="grp_FCV01"
               transform="rotate(-90,573.74638,564.77827)">
               <path
                  id="fcv01_body"
                  style={{
                     fill: '#ffffff',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }}
                  d="m 830.57745,337.11118 h -15.20001 l 7.51999,-13.28003 z m -15.20001,-26.40003 h 15.20001 l -7.68002,13.12 z"
                  className={clsfcv01_body} />
               <ellipse
                  style={{
                     fill: '#fefefe',
                     fillOpacity: 0,
                     stroke: '#000405',
                     strokeWidth: 0.5,
                     strokeDasharray: 'none'
                  }}
                  id="path9-7-0"
                  cx="822.91217"
                  cy="323.90903"
                  rx="3.7180016"
                  ry="3.7468233" />
               <g
                  id="g3074-9"
                  transform="translate(644.93603,-469.50273)">
                  <path
                     id="path1144-1-8"
                     d="m 191.37561,793.45873 h -9.44"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     id="path3073-2"
                     cx="197.28423"
                     cy="793.45056"
                     rx="6.0562205"
                     ry="6.1990557" />
                  <text
                     id="text3073-4"
                     style={{
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        fontWeight: 'normal',
                        fontStretch: 'normal',
                        fontSize: '9.33333px',
                        fontFamily: 'Calibri',
                        whiteSpace: 'pre',
                        shapeInside: 'url(#rect3073-1)',
                        display: 'inline',
                        fill: '#009900',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     transform="rotate(90,180.90494,790.79846)"><tspan
                        x="179.62891"
                        y="777.30729"
                        id="tspan214"><tspan
                           style={{
                              fill: '#000000'
                           }}
                           id="tspan213">M</tspan></tspan></text>
               </g>
            </g>
            <path
               id="hv30_body"
               style={{
                  fill: '#000000',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 966.69236,440.24561 v 15.20001 l -13.28003,-7.51999 z m -26.40003,15.20001 v -15.20001 l 13.12,7.68002 z"
               className={clshv30_body} />
            <text
               id="hv30_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-3.5404902,-288.35965)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan215">HV-30</tspan></text>
            <g
               id="grp_T01">
               <path
                  id="t01_body"
                  d="m 140.7363,467.80988 v 68.64002 h 205.92 v -68.64002 z"
                  style={{
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }}
                  className={clst01_body}
                  fill="url(#tk01fill)" />
               <text
                  id="t01_label"
                  style={{
                     fontStyle: 'normal',
                     fontVariant: 'normal',
                     fontWeight: 'normal',
                     fontStretch: 'normal',
                     fontSize: '9.33333px',
                     fontFamily: 'sans-serif',
                     fontVariantLigatures: 'normal',
                     fontVariantCaps: 'normal',
                     fontVariantNumeric: 'normal',
                     fontVariantEastAsian: 'normal',
                     textAlign: 'center',
                     whiteSpace: 'pre',
                     shapeInside: 'url(#rect3061-3-4)',
                     display: 'inline',
                     fill: '#000000',
                     fillOpacity: 1,
                     stroke: '#000405',
                     strokeWidth: 0.56,
                     strokeDasharray: 'none'
                  }}
                  transform="translate(-744.22571,-201.42895)"
                  className={clspagetext}
                  x="84.063774"
                  y="0"><tspan
                     x="964.88036"
                     y="751.86131"
                     id="tspan216">Sewage Pit
                  </tspan><tspan
                     x="979.445"
                     y="763.52799"
                     id="tspan217">T-01</tspan></text>
            </g>
            <g
               id="grp_P02"
               transform="rotate(-90,573.74638,564.77827)">
               <g
                  id="g19"
                  transform="rotate(-90,142.3473,299.58792)">
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.587747,
                        strokeDasharray: 'none'
                     }}
                     id="p02_body"
                     cx="167.00314"
                     cy="780.85254"
                     rx="15.983689"
                     ry="16.26936"
                     className={clsp02_body} />
                  <path
                     id="path1134-9-9"
                     d="m 153.1858,773.24334 13.7612,23.61176 13.76117,-23.61176"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.497623,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
               </g>
               <g
                  id="g14">
                  <path
                     id="path1144-1-7"
                     d="m 624.3066,248.98634 v 9.44"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     id="path3073-21"
                     cx="-243.07773"
                     cy="624.29846"
                     rx="6.0562205"
                     ry="6.1990557"
                     transform="rotate(-90)" />
                  <text
                     id="text3073-7"
                     style={{
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        fontWeight: 'normal',
                        fontStretch: 'normal',
                        fontSize: '9.33333px',
                        fontFamily: 'Calibri',
                        whiteSpace: 'pre',
                        shapeInside: 'url(#rect3073-9)',
                        display: 'inline',
                        fill: '#009900',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     transform="rotate(90,669.66023,729.07236)"><tspan
                        x="179.62891"
                        y="777.30729"
                        id="tspan219"><tspan
                           style={{
                              fill: '#000000'
                           }}
                           id="tspan218">M</tspan></tspan></text>
               </g>
            </g>
            <g
               id="grp_P01"
               transform="rotate(-90,573.74638,564.77827)">
               <g
                  id="g3073-5-9"
                  transform="rotate(-90,104.56875,262.402)">
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.587747,
                        strokeDasharray: 'none'
                     }}
                     id="p01_body"
                     cx="167.00314"
                     cy="780.85254"
                     rx="15.983689"
                     ry="16.26936"
                     className={clsp01_body} />
                  <path
                     id="path1134-9-9-0"
                     d="m 153.1858,773.24334 13.7612,23.61176 13.76117,-23.61176"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.497623,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
               </g>
               <g
                  id="g20">
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     id="path3073-21-1"
                     cx="-168.11327"
                     cy="623.70581"
                     rx="6.0562205"
                     ry="6.1990557"
                     transform="rotate(-90)" />
                  <g
                     id="g13"
                     transform="translate(0,0.18749999)">
                     <path
                        id="path1144-1-7-4"
                        d="m 623.71398,174.02188 v 9.44"
                        style={{
                           fill: 'none',
                           stroke: '#000000',
                           strokeWidth: 0.5,
                           strokeLinecap: 'round',
                           strokeLinejoin: 'round',
                           strokeMiterlimit: 10,
                           strokeDasharray: 'none',
                           strokeOpacity: 1
                        }} />
                     <text
                        id="text3073-7-0"
                        style={{
                           fontStyle: 'normal',
                           fontVariant: 'normal',
                           fontWeight: 'normal',
                           fontStretch: 'normal',
                           fontSize: '9.33333px',
                           fontFamily: 'Calibri',
                           whiteSpace: 'pre',
                           shapeInside: 'url(#rect3073-9-7)',
                           display: 'inline',
                           fill: '#009900',
                           fillOpacity: 1,
                           stroke: '#000405',
                           strokeWidth: 0.56,
                           strokeDasharray: 'none'
                        }}
                        transform="rotate(90,706.84615,691.29382)"><tspan
                           x="179.62891"
                           y="777.30729"
                           id="tspan221"><tspan
                              style={{
                                 fill: '#000000'
                              }}
                              id="tspan220">M</tspan></tspan></text>
                  </g>
               </g>
            </g>
            <text
               id="p01_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-9)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-745.28917,-226.9093)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan222">P-01</tspan></text>
            <text
               id="p02_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-9-4)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-669.8795,-227.6374)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan223">P-02</tspan></text>
            <path
               id="fcv01_line_in"
               d="m 284.1645,315.68746 h 33.98519"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.376362,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1,
                  markerEnd: 'url(#Triangle)'
               }}
               className={clsfcv01_line_in} />
            <path
               id="fcv01_line_out"
               d="m 345.94737,315.72438 h 16.06764"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1,
                  markerEnd: 'url(#Triangle)'
               }}
               className={clsfcv01_line_out} />
            <path
               id="hv27_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 216.80084,408.80906 h -15.20001 l 7.51999,-13.28003 z m -15.20001,-26.40003 h 15.20001 l -7.68002,13.12 z"
               className={clshv27_body} />
            <ellipse
               style={{
                  fill: '#fefefe',
                  fillOpacity: 0,
                  stroke: '#000405',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none'
               }}
               id="path9-7-0-3-8"
               cx="209.13554"
               cy="395.6069"
               rx="3.7180016"
               ry="3.7468233" />
            <text
               id="hv27_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-765.84506,-352.69016)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan224">HV-27</tspan></text>
            <path
               id="hv26_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 216.93285,452.20936 h -15.20001 l 7.51999,-13.28003 z m -15.20001,-26.40003 h 15.20001 l -7.68002,13.12 z"
               className={clshv26_body} />
            <ellipse
               style={{
                  fill: '#fefefe',
                  fillOpacity: 0,
                  stroke: '#000405',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none'
               }}
               id="path9-7-0-3-8-9"
               cx="209.26756"
               cy="439.00723"
               rx="3.7180016"
               ry="3.7468233" />
            <text
               id="hv26_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-9)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-766.01017,-309.587)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan225">HV-26</tspan></text>
            <path
               id="hv29_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 291.78055,409.47314 h -15.20001 l 7.51999,-13.28003 z m -15.20001,-26.40003 h 15.20001 l -7.68002,13.12 z"
               className={clshv29_body} />
            <ellipse
               style={{
                  fill: '#fefefe',
                  fillOpacity: 0,
                  stroke: '#000405',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none'
               }}
               id="path9-7-0-3-8-8"
               cx="284.11523"
               cy="396.27103"
               rx="3.7180016"
               ry="3.7468233" />
            <text
               id="hv29_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-4)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-690.56827,-351.13464)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan226">HV-29</tspan></text>
            <path
               id="hv28_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 291.91256,452.87344 h -15.20001 l 7.51999,-13.28003 z m -15.20001,-26.40003 h 15.20001 l -7.68002,13.12 z"
               className={clshv28_body} />
            <ellipse
               style={{
                  fill: '#fefefe',
                  fillOpacity: 0,
                  stroke: '#000405',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none'
               }}
               id="path9-7-0-3-8-9-9"
               cx="284.24725"
               cy="439.67136"
               rx="3.7180016"
               ry="3.7468233" />
            <text
               id="hv28_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-9-0)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-691.03056,-308.92301)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan227">HV-28</tspan></text>
            <path
               id="screening_line_out"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 459.90191,315.25685 h -19.97139 m 19.97804,83.66875 V 315.40558 M 442.9763,399.0099 v -83.52002"
               className={clsscreening_line_out} />
            <text
               id="screening_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-3-4-2)',
                  shapePadding: 0.148588,
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-568.08375,-433.74257)"
               className={clspagetext}><tspan
                  x="944.11719"
                  y="752.00974"
                  id="tspan228">Fine Screen</tspan></text>
            <path
               id="hv01_body"
               style={{
                  fill: '#000000',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 450.9058,425.15882 h -15.20001 l 7.51999,-13.28003 z m -15.20001,-26.40003 h 15.20001 l -7.68002,13.12 z"
               className={clshv01_body} />
            <ellipse
               style={{
                  fill: '#fefefe',
                  fillOpacity: 0,
                  stroke: '#000405',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none'
               }}
               id="path9-7-0-3-8-8-2"
               cx="443.24051"
               cy="411.9567"
               rx="3.7180016"
               ry="3.7468233" />
            <text
               id="hv01_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-4-5)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-539.26278,-337.47818)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan229">HV-01</tspan></text>
            <g
               id="grp_PC01"
               transform="translate(-623.78018,4.2324682)">
               <g
                  id="grp_pc01">
                  <path
                     id="pc01_body"
                     d="m 1078.38,342.31 v 72.8 l 32.48,60 32.48,-60 v -72.8"
                     style={{
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }}
                     className={clspc01_body}
                     fill="url(#pc01fill)" />
               </g>
               <text
                  id="pc01_label"
                  style={{
                     fontStyle: 'normal',
                     fontVariant: 'normal',
                     fontWeight: 'normal',
                     fontStretch: 'normal',
                     fontSize: '9.33333px',
                     fontFamily: 'sans-serif',
                     fontVariantLigatures: 'normal',
                     fontVariantCaps: 'normal',
                     fontVariantNumeric: 'normal',
                     fontVariantEastAsian: 'normal',
                     textAlign: 'center',
                     whiteSpace: 'pre',
                     shapeInside: 'url(#rect3061-3-4-2-3-4-9)',
                     display: 'inline',
                     fill: '#000000',
                     fillOpacity: 1,
                     stroke: '#000405',
                     strokeWidth: 0.56,
                     strokeDasharray: 'none'
                  }}
                  transform="translate(147.35139,-375.98886)"
                  className={clspagetext}
                  x="36.125637"
                  y="0"><tspan
                     x="946.24398"
                     y="751.86131"
                     id="tspan230">Primary
                  </tspan><tspan
                     x="946.21599"
                     y="763.52799"
                     id="tspan231">Clarifier
                  </tspan><tspan
                     x="950.8733"
                     y="775.19468"
                     id="tspan232">PC-01</tspan></text>
            </g>
            <g
               id="grp_P03"
               transform="rotate(-90,573.74638,564.77827)">
               <g
                  id="g22"
                  transform="rotate(-90,471.36867,290.81339)">
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.587747,
                        strokeDasharray: 'none'
                     }}
                     id="p03_body"
                     cx="167.00314"
                     cy="780.85254"
                     rx="15.983689"
                     ry="16.26936"
                     className={clsp03_body} />
                  <path
                     id="path1134-9-9-0-3"
                     d="m 153.1858,773.24334 13.7612,23.61176 13.76117,-23.61176"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.497623,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
               </g>
               <g
                  id="g9">
                  <path
                     id="path1144-1-7-4-3"
                     d="m 962.10252,569.2332 v 9.44"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     id="path3073-21-1-7"
                     cx="-563.32458"
                     cy="962.09436"
                     rx="6.0562205"
                     ry="6.1990557"
                     transform="rotate(-90)" />
                  <text
                     id="text3073-7-0-8"
                     style={{
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        fontWeight: 'normal',
                        fontStretch: 'normal',
                        fontSize: '9.33333px',
                        fontFamily: 'Calibri',
                        whiteSpace: 'pre',
                        shapeInside: 'url(#rect3073-9-7-1)',
                        display: 'inline',
                        fill: '#009900',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     transform="rotate(90,678.43476,1058.0938)"><tspan
                        x="179.62891"
                        y="777.30729"
                        id="tspan234"><tspan
                           style={{
                              fill: '#000000'
                           }}
                           id="tspan233">M</tspan></tspan></text>
               </g>
            </g>
            <text
               id="p03_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-9-7)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-349.41168,-565.08459)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan235">P-03</tspan></text>
            <text
               id="cds_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-3-4-2-35)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-377.13018,-539.88268)"
               className={clspagetext}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan236">CDS</tspan></text>
            <path
               id="p03_line_out"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1,
                  markerEnd: 'url(#marker1)'
               }}
               d="M 604.21063,147.35729 H 501.95654 m 102.23241,13.51524 V 147.75366 M 501.66468,147.42587 V 362.1777"
               className={clsp03_line_out} />
            <g
               id="grp_T02">
               <path
                  id="t02_body"
                  d="m 532.73628,471.96986 h 53.60001 V 359.80988 h -53.60001 z"
                  style={{
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }}
                  className={clst02_body}
                  fill="url(#tk02fill)" />
               <text
                  id="t02_label"
                  style={{
                     fontStyle: 'normal',
                     fontVariant: 'normal',
                     fontWeight: 'normal',
                     fontStretch: 'normal',
                     fontSize: '9.33333px',
                     fontFamily: 'sans-serif',
                     fontVariantLigatures: 'normal',
                     fontVariantCaps: 'normal',
                     fontVariantNumeric: 'normal',
                     fontVariantEastAsian: 'normal',
                     textAlign: 'center',
                     whiteSpace: 'pre',
                     shapeInside: 'url(#rect3061-3-4-28)',
                     display: 'inline',
                     fill: '#000000',
                     fillOpacity: 1,
                     stroke: '#000405',
                     strokeWidth: 0.56,
                     strokeDasharray: 'none'
                  }}
                  transform="translate(-432.50098,-270.32232)"
                  className={clspagetext}
                  x="112.45569"
                  y="0"><tspan
                     x="949.91662"
                     y="751.86131"
                     id="tspan237">Preconditioning
                  </tspan><tspan
                     x="974.56592"
                     y="763.52799"
                     id="tspan238">Tank
                  </tspan><tspan
                     x="975.53192"
                     y="775.19468"
                     id="tspan239">T-02</tspan></text>
            </g>
            <path
               id="ls01_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.463976,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 580.28425,383.35704 -0.11802,-30.33526 m -16.31309,-16.68533 h 32.7953 m -16.1801,-16.59607 a 16.597471,16.51177 0 0 1 16.5975,16.51177 16.597471,16.51177 0 0 1 -16.5975,16.51177 16.597471,16.51177 0 0 1 -16.5975,-16.51177 16.597471,16.51177 0 0 1 16.5975,-16.51177 z"
               className={clsls01_body} />
            <text
               id="ls01_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-8-8-6-2)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-372.99809,-418.66472)"><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan240">LS01</tspan></text>
            <text
               id="mv01_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-6)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-512.15213,-210.58943)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan241">MV-01</tspan></text>
            <g
               id="g26"
               transform="rotate(-90,573.74638,564.77827)">
               <path
                  id="mv01_body"
                  style={{
                     fill: '#000000',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }}
                  d="m 613.65374,470.01797 v 15.20001 l -13.28003,-7.51999 z m -26.40003,15.20001 v -15.20001 l 13.12,7.68002 z"
                  className={clsmv01_body} />
               <ellipse
                  style={{
                     fill: '#fefefe',
                     fillOpacity: 0,
                     stroke: '#000405',
                     strokeWidth: 0.5,
                     strokeDasharray: 'none'
                  }}
                  id="path9-7-0-0"
                  cx="-477.68326"
                  cy="600.4516"
                  rx="3.7180016"
                  ry="3.7468233"
                  transform="rotate(-90)" />
               <g
                  id="grp_MV01_M">
                  <path
                     id="path1144-1-8-5"
                     d="m 600.49856,464.28378 v 9.44"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     id="path3073-2-5"
                     cx="-458.37515"
                     cy="600.49042"
                     rx="6.0562205"
                     ry="6.1990557"
                     transform="rotate(-90)" />
                  <text
                     id="text3073-4-4"
                     style={{
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        fontWeight: 'normal',
                        fontStretch: 'normal',
                        fontSize: '9.33333px',
                        fontFamily: 'Calibri',
                        whiteSpace: 'pre',
                        shapeInside: 'url(#rect3073-1-5)',
                        display: 'inline',
                        fill: '#009900',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     transform="rotate(90,550.10749,824.81706)"><tspan
                        x="179.62891"
                        y="777.30729"
                        id="tspan243"><tspan
                           style={{
                              fill: '#000000'
                           }}
                           id="tspan242">M</tspan></tspan></text>
               </g>
            </g>
            <path
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.499904,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 487.00119,479.58609 -0.0796,44.96054"
               id="mv01_line_in"
               className={clsmv01_line_in} />
            <path
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.499081,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 486.79954,551.23522 -0.0649,70.04845"
               id="mv01_line_out"
               className={clsmv01_line_out} />
            <path
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.486793,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 860.11198,621.59252 -373.33045,-0.0334"
               id="p04_line_in_1"
               className={clsp04_line_in_1} />
            <path
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.473119,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 1110.7456,621.61947 -250.2247,-0.047"
               id="p04_line_in_3"
               className={clsp04_line_in_3} />
            <path
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.495586,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 860.31537,621.57877 -0.14632,-6.0775"
               id="p04_line_in_2"
               className={clsp04_line_in_2} />
            <path
               id="t03_line_in"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.482872,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 586.44216,363.02412 39.07816,0.0986 m 0.17595,0.0471 v 94.56 h 45.92005"
               className={clst03_line_in} />
            <text
               id="t03_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-3-4-28-5)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-319.3974,-283.26712)"
               className={clspagetext}
               x="62.471333"
               y="0"><tspan
                  x="947.44588"
                  y="751.86131"
                  id="tspan245"><tspan
                     style={{
                        textAlign: 'center',
                        textAnchor: 'middle'
                     }}
                     id="tspan244">Algaesys
                  </tspan></tspan><tspan
                     x="956.3872"
                     y="763.52799"
                     id="tspan247"><tspan
                        style={{
                           textAlign: 'center',
                           textAnchor: 'middle'
                        }}
                        id="tspan246">Tank
                  </tspan></tspan><tspan
                     x="957.35321"
                     y="775.19468"
                     id="tspan249"><tspan
                        style={{
                           textAlign: 'center',
                           textAnchor: 'middle'
                        }}
                        id="tspan248">T-03</tspan></tspan></text>
            <g
               id="grp_P05"
               transform="rotate(-90,573.74638,564.77827)">
               <g
                  id="g3073-5-9-7-3-8"
                  transform="matrix(1,0,0,-1,391.44819,1490.7432)">
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.587747,
                        strokeDasharray: 'none'
                     }}
                     id="p05_body"
                     cx="167.00314"
                     cy="780.85254"
                     rx="15.983689"
                     ry="16.26936"
                     className={clsp05_body} />
                  <path
                     id="path1134-9-9-0-3-4-7"
                     d="m 153.1858,773.24334 13.7612,23.61176 13.76117,-23.61176"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.497623,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
               </g>
               <g
                  id="g3074-7-5-4-6-2"
                  transform="matrix(1,0,0,-1,393.02146,1502.6547)">
                  <path
                     id="path1144-1-7-4-3-8-5"
                     d="m 191.37561,793.45873 h -9.44"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     id="path3073-21-1-7-5-0"
                     cx="197.28423"
                     cy="793.45056"
                     rx="6.0562205"
                     ry="6.1990557" />
                  <text
                     id="text3073-7-0-8-4-7"
                     style={{
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        fontWeight: 'normal',
                        fontStretch: 'normal',
                        fontSize: '9.33333px',
                        fontFamily: 'Calibri',
                        whiteSpace: 'pre',
                        shapeInside: 'url(#rect3073-9-7-1-9-7)',
                        display: 'inline',
                        fill: '#009900',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     transform="rotate(90,180.90494,790.79846)"><tspan
                        x="179.62891"
                        y="777.30729"
                        id="tspan251"><tspan
                           style={{
                              fill: '#000000'
                           }}
                           id="tspan250">M</tspan></tspan></text>
               </g>
            </g>
            <text
               id="p05_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-9-7-6-1)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-231.8323,-168.78419)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan252">P-05</tspan></text>
            <path
               id="hv03_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 773.83426,543.87669 h -15.20001 l 7.51999,-13.28003 z m -15.20001,-26.40003 h 15.20001 l -7.68002,13.12 z"
               className={clshv03_body} />
            <ellipse
               style={{
                  fill: '#fefefe',
                  fillOpacity: 0,
                  stroke: '#000405',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none'
               }}
               id="path9-7-0-3-8-8-7-9"
               cx="766.41357"
               cy="530.7561"
               rx="3.7180016"
               ry="3.7468233" />
            <text
               id="hv03_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-4-4-1)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-169.33695,-217.46819)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan253">HV-03</tspan></text>
            <path
               id="p05_line_in"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 766.28397,580.36208 -31.10348,-0.10625 m 31.26882,-36.47164 -0.09,36.57305"
               className={clsp05_line_in} />
            <path
               id="hv03_line_in"
               d="m 766.28426,506.28523 v 11.03012"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clshv03_line_in} />
            <path
               id="ae01a_orp_ph_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.510064,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 733.46691,456.03807 -0.0719,-60.14847 m -16.45146,-16.36251 h 32.7953 m -16.1801,-16.59607 a 16.597471,16.51177 0 0 1 16.5975,16.51177 16.597471,16.51177 0 0 1 -16.5975,16.51177 16.597471,16.51177 0 0 1 -16.5975,-16.51177 16.597471,16.51177 0 0 1 16.5975,-16.51177 z"
               className={clsae01a_orp_ph_body} />
            <text
               id="ae01a_orp_ph_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  textAlign: 'center',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-8-8-5)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-249.86153,-391.34779)"
               className={clslabeltext}
               x="36.355782"
               y="0"><tspan
                  x="952.38267"
                  y="751.86131"
                  id="tspan254">AE01A ORP+pH</tspan></text>
            <text
               id="ae01a_orp_ph_value"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  textAlign: 'center',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-5-6-1)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-222.56918,-428.53412)"
               className={clsshowsensor}
               x="62.072571"
               y="0"><tspan
                  x="963.33723"
                  y="751.86131"
                  id="tspan255">{ae01a_orp_ph_1}</tspan></text>
            <path
               id="ae01a_do_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.449978,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 684.37631,455.97197 -0.13202,-25.50721 M 667.9382,413.78643 h 32.7953 m -16.1801,-16.59607 a 16.597471,16.51177 0 0 1 16.5975,16.51177 16.597471,16.51177 0 0 1 -16.5975,16.51177 16.597471,16.51177 0 0 1 -16.5975,-16.51177 16.597471,16.51177 0 0 1 16.5975,-16.51177 z"
               className={clsae01a_do_body} />
            <text
               id="ae01a_do_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  textAlign: 'center',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-8-8-5-9)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-285.43055,-370.10853)"
               className={clsshowsensorlabel}
               x="23.855135"
               y="0"><tspan
                  x="948.09777"
                  y="751.86131"
                  id="tspan256">AE01A DO</tspan></text>
            <text
               id="ae01a_do_value"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  textAlign: 'center',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-5-6-1-1)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-282.47304,-359.50624)"
               className={clsvaluetext}
               x="51.253563"
               y="0"><tspan
                  x="969.72826"
                  y="751.86131"
                  id="tspan257">{ae01a_do_1}</tspan></text>
            <path
               id="ae01b_orp_ph_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.510064,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 875.87841,454.23808 -0.0719,-60.14847 M 859.35505,377.7271 h 32.7953 m -16.1801,-16.59607 a 16.597471,16.51177 0 0 1 16.5975,16.51177 16.597471,16.51177 0 0 1 -16.5975,16.51177 16.597471,16.51177 0 0 1 -16.5975,-16.51177 16.597471,16.51177 0 0 1 16.5975,-16.51177 z"
               className={clsae01b_orp_ph_body} />
            <text
               id="ae01b_orp_ph_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  textAlign: 'center',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-8-8-5-3)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-106.7678,-393.17314)"
               className={clslabeltext}
               x="36.364895"
               y="0"><tspan
                  x="949.65654"
                  y="751.86131"
                  id="tspan258">AE01B ORP+pH</tspan></text>
            <text
               id="ae01b_orp_ph_value"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  textAlign: 'center',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-5-6-1-6)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-81.67945,-433.57441)"
               className={clsshowsensor}
               x="62.177387"
               y="0"><tspan
                  x="966.44754"
                  y="751.86131"
                  id="tspan259">{ae01b_orp_ph_1}</tspan></text>
            <path
               id="ae01b_do_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.449978,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 826.78781,454.17198 -0.13202,-25.50721 M 810.3497,411.98644 h 32.7953 m -16.1801,-16.59607 a 16.597471,16.51177 0 0 1 16.5975,16.51177 16.597471,16.51177 0 0 1 -16.5975,16.51177 16.597471,16.51177 0 0 1 -16.5975,-16.51177 16.597471,16.51177 0 0 1 16.5975,-16.51177 z"
               className={clsae01b_do_body} />
            <text
               id="ae01b_do_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  textAlign: 'center',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-8-8-5-9-4)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-143.31593,-369.90853)"
               className={clsshowsensorlabel}
               x="23.86425"
               y="0"><tspan
                  x="948.34331"
                  y="751.86131"
                  id="tspan260">AE01B DO</tspan></text>
            <text
               id="ae01b_do_value"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  textAlign: 'center',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-5-6-1-1-2)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-137.06154,-360.30624)"
               className={clsvaluetext}
               x="102.71677"
               y="0"><tspan
                  x="969.47626"
                  y="751.86131"
                  id="tspan261">{ae01b_do_1}</tspan></text>
            <path
               id="path1604-9-9-8"
               d="m 920.87273,459.26134 v -5.95312 h 0.7813 v 2.45312 h 3.0937 v -2.45312 h 0.7813 v 5.95312 h -0.7813 v -2.79687 h -3.0937 v 2.79687 z m 5.8438,0 v -5.95312 h 0.7812 v 5.25 h 2.9375 v 0.70312 z m 0,0"
               style={{
                  fill: '#000000',
                  fillOpacity: 1,
                  fillRule: 'nonzero',
                  stroke: 'none',
                  strokeWidth: 0.025391
               }}
               aria-label="HL" />
            <path
               id="ls02_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.463976,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 916.50629,468.37329 -0.11802,-30.33526 M 900.07518,421.3527 h 32.7953 m -16.1801,-16.59607 a 16.597471,16.51177 0 0 1 16.5975,16.51177 16.597471,16.51177 0 0 1 -16.5975,16.51177 16.597471,16.51177 0 0 1 -16.5975,-16.51177 16.597471,16.51177 0 0 1 16.5975,-16.51177 z"
               className={clsls02_body} />
            <text
               id="ls02_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-8-8-6-2-2)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-37.694624,-333.12248)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan262">LS02</tspan></text>
            <path
               id="ls03_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.529279,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 1010.5662,531.5441 -0.053,-88.37454 m -16.3456,-16.71798 h 32.7952 m -16.1801,-16.59607 a 16.597471,16.51177 0 0 1 16.5975,16.51177 16.597471,16.51177 0 0 1 -16.5975,16.51177 16.597471,16.51177 0 0 1 -16.5974,-16.51177 16.597471,16.51177 0 0 1 16.5974,-16.51177 z"
               className={clsls03_body} />
            <text
               id="ls03_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-8-8-6-2-7)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               transform="translate(55.384093,-327.57783)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan263">LS03</tspan></text>
            <text
               id="t05_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-3-4-28-5-9)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-3.030596,-208.65114)"
               className={clspagetext}
               x="42.136703"
               y="0"><tspan
                  x="952.23514"
                  y="751.86131"
                  id="tspan265"><tspan
                     style={{
                        textAlign: 'center',
                        textAnchor: 'middle'
                     }}
                     id="tspan264">Equalisation
                  </tspan></tspan><tspan
                     x="959.59446"
                     y="763.52799"
                     id="tspan267"><tspan
                        style={{
                           textAlign: 'center',
                           textAnchor: 'middle'
                        }}
                        id="tspan266">Tank T-05</tspan></tspan></text>
            <path
               id="hv04_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 961.39361,502.83232 v 15.20001 l -13.28003,-7.51999 z m -26.40003,15.20001 v -15.20001 l 13.12,7.68002 z"
               className={clshv04_body} />
            <ellipse
               style={{
                  fill: '#fefefe',
                  fillOpacity: 0,
                  stroke: '#000405',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none'
               }}
               id="path9-7-0-3-8-8-7-9-6"
               cx="-510.25317"
               cy="948.27301"
               rx="3.7180016"
               ry="3.7468233"
               transform="rotate(-90)" />
            <text
               id="hv04_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-4-4-1-2)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-7.9634452,-225.20661)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan268">HV-04</tspan></text>
            <path
               id="p06_line_in"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 1063.0863,533.82828 v 26.163 m -11.765,0.0329 h 11.6478"
               className={clsp06_line_in} />
            <path
               id="hv06_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 1050.879,552.44576 v 15.20001 l -13.28,-7.51999 z m -26.4,15.20001 v -15.20001 l 13.12,7.68002 z"
               className={clshv06_body} />
            <ellipse
               style={{
                  fill: '#fefefe',
                  fillOpacity: 0,
                  stroke: '#000405',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none'
               }}
               id="path9-7-0-3-8-8-7-9-6-6"
               cx="-559.86652"
               cy="1037.7585"
               rx="3.7180016"
               ry="3.7468233"
               transform="rotate(-90)" />
            <text
               id="hv06_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-4-4-1-2-3)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(81.521945,-175.59318)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan269">HV-06</tspan></text>
            <g
               id="grp_P06"
               transform="rotate(-90,573.74638,564.77827)">
               <g
                  id="g3073-5-9-7-3-8-2"
                  transform="rotate(-90,530.52496,690.24929)">
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.587747,
                        strokeDasharray: 'none'
                     }}
                     id="p06_body"
                     cx="167.00314"
                     cy="780.85254"
                     rx="15.983689"
                     ry="16.26936"
                     className={clsp06_body} />
                  <path
                     id="path1134-9-9-0-3-4-7-5"
                     d="m 153.1858,773.24334 13.7612,23.61176 13.76117,-23.61176"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.497623,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
               </g>
               <g
                  id="g7">
                  <path
                     id="path1144-1-7-4-3-8-5-2"
                     d="m 620.43357,1027.8254 v 9.44"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     id="path3073-21-1-7-5-0-9"
                     cx="-1021.9167"
                     cy="-620.44171"
                     rx="6.0562205"
                     ry="6.1990557"
                     transform="matrix(0,-1,-1,0,0,0)" />
                  <text
                     id="text3073-7-0-8-4-7-1"
                     style={{
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        fontWeight: 'normal',
                        fontStretch: 'normal',
                        fontSize: '9.33333px',
                        fontFamily: 'Calibri',
                        whiteSpace: 'pre',
                        shapeInside: 'url(#rect3073-9-7-1-9-7-7)',
                        display: 'inline',
                        fill: '#009900',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     transform="matrix(0,-1,-1,0,1394.7524,1205.4888)"><tspan
                        x="179.62891"
                        y="777.30729"
                        id="tspan271"><tspan
                           style={{
                              fill: '#000000'
                           }}
                           id="tspan270">M</tspan></tspan></text>
               </g>
            </g>
            <text
               id="p06_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-9-7-6-1-2)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(107.774,-224.28976)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan272">P-06</tspan></text>
            <g
               id="grp_PC02">
               <g
                  id="grp_pc02">
                  <path
                     id="pc02_body"
                     d="M 1078.38,342.31 V 415.11 l 32.48,60 32.48,-60 V 342.31"
                     style={{
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }}
                     className={clspc02_body}
                     fill="url(#pc02fill)" />
               </g>
               <text
                  id="pc02_label"
                  style={{
                     fontStyle: 'normal',
                     fontVariant: 'normal',
                     fontWeight: 'normal',
                     fontStretch: 'normal',
                     fontSize: '9.33333px',
                     fontFamily: 'sans-serif',
                     fontVariantLigatures: 'normal',
                     fontVariantCaps: 'normal',
                     fontVariantNumeric: 'normal',
                     fontVariantEastAsian: 'normal',
                     textAlign: 'center',
                     whiteSpace: 'pre',
                     shapeInside: 'url(#rect3061-3-4-2-3-4)',
                     display: 'inline',
                     fill: '#000000',
                     fillOpacity: 1,
                     stroke: '#000405',
                     strokeWidth: 0.56,
                     strokeDasharray: 'none'
                  }}
                  transform="translate(140.66493,-375.5431)"
                  className={clspagetext}
                  x="36.125637"
                  y="0"><tspan
                     x="947.45983"
                     y="751.86131"
                     id="tspan273">Secondary
                  </tspan><tspan
                     x="953.12516"
                     y="763.52799"
                     id="tspan274">Clarifier
                  </tspan><tspan
                     x="957.78248"
                     y="775.19468"
                     id="tspan275">PC-02</tspan></text>
            </g>
            <path
               id="p06_line_out"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.498257,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 1062.8273,329.67467 h 20.0022 m 0.014,0.13588 v 27.27589 m -20.0981,-27.37115 v 171.16618"
               className={clsp06_line_out} />
            <text
               id="mv02_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-6-2)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(178.37051,-197.77322)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan276">MV-02</tspan></text>
            <g
               id="grp_MV02"
               transform="rotate(-90,573.74638,564.77827)">
               <path
                  id="mv02_body"
                  style={{
                     fill: '#000000',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }}
                  d="m 601.83753,1094.2281 v 15.2 l -13.28003,-7.52 z m -26.40003,15.2 v -15.2 l 13.12,7.68 z"
                  className={clsmv02_body} />
               <ellipse
                  style={{
                     fill: '#fefefe',
                     fillOpacity: 0,
                     stroke: '#000405',
                     strokeWidth: 0.5,
                     strokeDasharray: 'none'
                  }}
                  id="path9-7-0-0-6"
                  cx="-1101.8934"
                  cy="588.63538"
                  rx="3.7180016"
                  ry="3.7468233"
                  transform="rotate(-90)" />
               <ellipse
                  style={{
                     fill: '#ffffff',
                     fillOpacity: 1,
                     stroke: '#000405',
                     strokeWidth: 0.56,
                     strokeDasharray: 'none'
                  }}
                  id="path3073-2-5-9"
                  cx="-1082.5853"
                  cy="588.67419"
                  rx="6.0562205"
                  ry="6.1990557"
                  transform="rotate(-90)" />
               <path
                  id="path1144-1-8-5-2"
                  d="m 588.68235,1088.4939 v 9.44"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
               <text
                  id="text3073-4-4-3"
                  style={{
                     fontStyle: 'normal',
                     fontVariant: 'normal',
                     fontWeight: 'normal',
                     fontStretch: 'normal',
                     fontSize: '9.33333px',
                     fontFamily: 'Calibri',
                     whiteSpace: 'pre',
                     shapeInside: 'url(#rect3073-1-5-0)',
                     display: 'inline',
                     fill: '#009900',
                     fillOpacity: 1,
                     stroke: '#000405',
                     strokeWidth: 0.56,
                     strokeDasharray: 'none'
                  }}
                  transform="rotate(90,232.09432,1131.014)"><tspan
                     x="179.62891"
                     y="777.30729"
                     id="tspan278"><tspan
                        style={{
                           fill: '#000000'
                        }}
                        id="tspan277">M</tspan></tspan></text>
            </g>
            <path
               id="t01_line_in"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 376.87495,623.74993 v 53.71517 m 0.0286,-58.2707 c 3.36777,0.36419 2.88126,4.12704 0,4.20228 m -0.039,-207.73625 v 203.3292 m 0.14859,-203.4566 h -39.59369 v 69.45134"
               className={clst01_line_in} />
            <path
               id="hv10_line_out"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 1282.7181,638.06769 v 23.13248 m -834.77758,-0.23251 h 834.89428 m -861.93579,0.76221 h -43.67932"
               className={clshv10_line_out} />
            <path
               id="mv04_recirculate_line_out"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 1171.1556,690.10361 c 3.3678,0.36419 2.8813,4.12704 0,4.20228 m -794.12993,-49.7599 h 794.04043 m 0.069,0.12557 v 14.21821 m -0.01,4.23666 v 26.90064 m 0.016,4.39052 v 9.06196 m -0.021,-44.53219 c 3.3678,0.36419 2.8813,4.12704 0,4.20228"
               className={clsmv04_recirculate_line_out} />
            <path
               id="ls05_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.463976,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 1171.0874,373.41777 h 32.7953 m -16.1801,-16.59607 a 16.597471,16.51177 0 0 1 16.5975,16.51177 16.597471,16.51177 0 0 1 -16.5975,16.51177 16.597471,16.51177 0 0 1 -16.5975,-16.51177 16.597471,16.51177 0 0 1 16.5975,-16.51177 z m 0.3008,120.27818 v -87.00475"
               className={clsls05_body} />
            <text
               id="ls05_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-8-8-6-2-2-2)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(232.89516,-380.8286)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan279">LS05</tspan></text>
            <text
               id="t06_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-3-4-28-5-9-1)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(212.21009,-262.46999)"
               className={clspagetext}
               x="42.136703"
               y="0"><tspan
                  x="952.91522"
                  y="751.86131"
                  id="tspan281"><tspan
                     style={{
                        textAlign: 'center',
                        textAnchor: 'middle'
                     }}
                     id="tspan280">Buffer </tspan></tspan><tspan
                        x="956.3872"
                        y="763.52799"
                        id="tspan283"><tspan
                           style={{
                              textAlign: 'center',
                              textAnchor: 'middle'
                           }}
                           id="tspan282">Tank
                  </tspan></tspan><tspan
                     x="957.35321"
                     y="775.19468"
                     id="tspan285"><tspan
                        style={{
                           textAlign: 'center',
                           textAnchor: 'middle'
                        }}
                        id="tspan284">T-06</tspan></tspan></text>
            <text
               id="mv03_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-4-5-0-4-9)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(282.3465,-310.04151)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan286">MV-03</tspan></text>
            <path
               id="mv03_common_line_out"
               d="m 1251.9033,469.30209 h 25.3544"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clsmv03_common_line_out} />
            <g
               id="grp_MV03"
               transform="rotate(-90,573.74638,564.77827)">
               <g
                  id="grp_MV03_M"
                  transform="translate(491.13241,435.92884)">
                  <path
                     id="path1144-1-60"
                     d="m 191.37561,793.45873 h -9.44"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     id="path3073-0"
                     cx="197.28423"
                     cy="793.45056"
                     rx="6.0562205"
                     ry="6.1990557" />
                  <text
                     id="text3073-2"
                     style={{
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        fontWeight: 'normal',
                        fontStretch: 'normal',
                        fontSize: '9.33333px',
                        fontFamily: 'Calibri',
                        whiteSpace: 'pre',
                        shapeInside: 'url(#rect3073-00)',
                        display: 'inline',
                        fill: '#009900',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     transform="rotate(90,180.90494,790.79846)"><tspan
                        x="179.62891"
                        y="777.30729"
                        id="tspan288"><tspan
                           style={{
                              fill: '#000000'
                           }}
                           id="tspan287">M</tspan></tspan></text>
               </g>
               <g
                  id="g25">
                  <path
                     style={{
                        fill: '#ffffff',
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }}
                     d="m 655.85736,1236.956 13.28,-7.5201 -13.28,-7.52 z"
                     id="mv03_backwash"
                     className={clsmv03_backwash} />
                  <path
                     id="mv03_filtering"
                     d="m 661.61746,1216.1559 h 15.04 l -7.5201,13.28 z"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }}
                     className={clsmv03_filtering} />
                  <path
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }}
                     d="m 676.65746,1242.7158 h -15.04 l 7.5199,-13.2799 z"
                     id="mv03_common"
                     className={clsmv03_common} />
                  <ellipse
                     style={{
                        fill: '#fefefe',
                        fillOpacity: 0,
                        stroke: '#000405',
                        strokeWidth: 0.5,
                        strokeDasharray: 'none'
                     }}
                     id="path9-7-0-3-8-8-2-4-8-5"
                     cx="1229.4325"
                     cy="-668.96472"
                     rx="3.7180016"
                     ry="3.7468233"
                     transform="rotate(90)" />
               </g>
            </g>
            <path
               id="mv04_common_line_in"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.546288,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 1184.5175,717.0297 h 119.3564 m 0.062,-19.16833 v 19.03326"
               className={clswmv04_common_line_in} />
            <path
               id="mv03_backwash_line_in"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.485333,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 464.39016,903.11658 h 774.24144 m 0.018,-183.72301 v 183.68628 m -0.1034,-239.61649 v 51.60873 m 0.023,-133.40703 v 77.43504 m -0.07,-176.36398 v 94.69435 m 0.09,0.0296 c 3.1705,0.36448 2.7125,4.13029 0,4.20558 m 0.077,133.41686 c 3.1705,0.36447 2.7125,4.13028 0,4.20558 m -0.052,-60.13666 c 3.1705,0.36447 2.7125,4.13028 0,4.20558"
               className={clsmv03_backwash_line_in} />
            <path
               style={{
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000000',
                  strokeWidth: 0.290242,
                  strokeDasharray: 'none',
                  strokeDashoffset: 0,
                  strokeOpacity: 0.92
               }}
               d="m 867.51659,899.71721 v 6.80633 l 10.7521,-3.46004 z"
               id="mv03_backwash_line_in_flow" />
            <path
               id="hv17_line_out"
               d="M 464.1083,903.11601 H 416.51444"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clshv17_line_out} />
            <path
               id="p09_line_out"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 1351.1143,502.46947 v 58.05157 m -58.3627,-58.20051 h 58.406 m -58.3819,-16.51449 v 26.89832"
               className={clsp09_line_out} />
            <path
               id="hv08_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 1300.2136,539.48176 h -15.2 l 7.52,-13.28003 z m -15.2,-26.40003 h 15.2 l -7.68,13.12 z"
               className={clshv08_body} />
            <ellipse
               style={{
                  fill: '#fefefe',
                  fillOpacity: 0,
                  stroke: '#000405',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none'
               }}
               id="path9-7-0-3-8-8-2-4-8-2"
               cx="1292.5482"
               cy="526.27966"
               rx="3.7180016"
               ry="3.7468233" />
            <text
               id="hv08_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-4-5-0-4-6)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(359.28071,-222.22631)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan289">HV-08</tspan></text>
            <g
               id="grp_P09"
               transform="rotate(-90,573.74638,564.77827)">
               <ellipse
                  style={{
                     fill: '#ffffff',
                     fillOpacity: 1,
                     stroke: '#000405',
                     strokeWidth: 0.587747,
                     strokeDasharray: 'none'
                  }}
                  id="ellipse5"
                  cx="669.18915"
                  cy="-1284.0632"
                  rx="15.983689"
                  ry="16.26936"
                  className={clsp09_body}
                  transform="scale(1,-1)" />
               <path
                  id="path1134-9-9-0-3-4-7-0"
                  d="m 677.31498,1297.6494 -23.6118,-13.7612 23.6118,-13.7612"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.497623,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
               <g
                  id="g3074-7-5-4-6-2-6"
                  transform="matrix(1,0,0,-1,503.62672,2077.5344)">
                  <path
                     id="path1144-1-7-4-3-8-5-6"
                     d="m 191.37561,793.45873 h -9.44"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     id="path3073-21-1-7-5-0-8"
                     cx="197.28423"
                     cy="793.45056"
                     rx="6.0562205"
                     ry="6.1990557" />
                  <text
                     id="text3073-7-0-8-4-7-3"
                     style={{
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        fontWeight: 'normal',
                        fontStretch: 'normal',
                        fontSize: '9.33333px',
                        fontFamily: 'Calibri',
                        whiteSpace: 'pre',
                        shapeInside: 'url(#rect3073-9-7-1-9-7-5)',
                        display: 'inline',
                        fill: '#009900',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     transform="rotate(90,180.90494,790.79846)"><tspan
                        x="179.62891"
                        y="777.30729"
                        id="tspan291"><tspan
                           style={{
                              fill: '#000000'
                           }}
                           id="tspan290">M</tspan></tspan></text>
               </g>
            </g>
            <text
               id="p09_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-9-7-6-1-5)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(338.64402,-286.03325)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan292">P-09</tspan></text>
            <path
               id="hv08_line_out"
               d="m 1292.6296,539.49643 v 9.09147"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.40408,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clshv08_line_out} />
            <g
               id="grp_MMF">
               <path
                  id="mmf_body"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }}
                  d="M 1311.51,584.89863 V 567.6186 m -37.7601,17.28003 0.16,2.4 0.48,2.56 0.8,2.24 1.12,2.24 1.28,2.08 1.76,1.76 1.76,1.76 2.08,1.28 2.24,1.12 2.24,0.8 2.56,0.48 2.4,0.16 2.4,-0.16 2.56,-0.48 2.24,-0.8 2.24,-1.12 2.08,-1.28 1.76,-1.76 1.76,-1.76 1.28,-2.08 1.12,-2.24 0.8,-2.24 0.48,-2.56 0.16,-2.4 m -37.76,-17.28003 v 17.28003 m 37.7601,-17.28003 -0.16,-2.4 -0.48,-2.56 -0.8,-2.24 -1.12,-2.24 -1.28,-2.08 -1.76,-1.76 -1.76,-1.76 -2.08,-1.28 -2.24,-1.12 -2.24,-0.8 -2.56,-0.48 -2.4,-0.16 -2.4,0.16 -2.56,0.48 -2.24,0.8 -2.24,1.12 -2.08,1.28 -1.76,1.76 -1.76,1.76 -1.28,2.08 -1.12,2.24 -0.8,2.24 -0.48,2.56 -0.16,2.4"
                  className={clsmmf_body} />
               <text
                  id="mmf_label"
                  style={{
                     fontStyle: 'normal',
                     fontVariant: 'normal',
                     fontWeight: 'normal',
                     fontStretch: 'normal',
                     fontSize: '9.33333px',
                     fontFamily: 'sans-serif',
                     fontVariantLigatures: 'normal',
                     fontVariantCaps: 'normal',
                     fontVariantNumeric: 'normal',
                     fontVariantEastAsian: 'normal',
                     textAlign: 'center',
                     whiteSpace: 'pre',
                     shapeInside: 'url(#rect3061-3-4-2-3-4-3)',
                     display: 'inline',
                     fill: '#000000',
                     fillOpacity: 1,
                     stroke: '#000405',
                     strokeWidth: 0.56,
                     strokeDasharray: 'none'
                  }}
                  transform="translate(332.37716,-187.05356)"
                  className={clspagetext}
                  x="30.907541"
                  y="0"><tspan
                     x="948.56509"
                     y="751.86131"
                     id="tspan293">Multi
                  </tspan><tspan
                     x="946.21776"
                     y="763.52799"
                     id="tspan294">Media
                  </tspan><tspan
                     x="948.70043"
                     y="775.19468"
                     id="tspan295">Filter</tspan></text>
            </g>
            <path
               id="hv13_line_out"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="M 1411.221,661.7697 V 405.81383 m -12.158,256.12629 h 12.1731 M 1194.0435,405.83345 h 216.9939"
               className={clshv13_line_out} />
            <text
               id="ae02_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-8-8-5-9-4-1)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(366.7214,-377.3814)"
               className={clsshowsensorlabel}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan296">AE02</tspan></text>
            <text
               id="ae02_turbidity_value"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  textAlign: 'center',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-5-6-1-1-2-1)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(338.46144,-366.2518)"
               className={clsvaluetext}
               x="62.448547"
               y="0"><tspan
                  x="985.99538"
                  y="751.86131"
                  id="tspan297">{ae02_1}</tspan></text>
            <path
               id="hv11_body"
               style={{
                  fill: '#000000',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 1358.7931,586.52464 h -15.2 l 7.52,-13.28003 z m -15.2,-26.40003 h 15.2 l -7.68,13.12 z"
               className={clshv11_body} />
            <ellipse
               style={{
                  fill: '#fefefe',
                  fillOpacity: 0,
                  stroke: '#000405',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none'
               }}
               id="path9-7-0-3-8-8-2-4-8-2-7"
               cx="1351.1277"
               cy="573.32257"
               rx="3.7180016"
               ry="3.7468233" />
            <text
               id="hv11_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-4-5-0-4-6-8)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(417.86021,-175.18343)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan298">HV-11</tspan></text>
            <path
               id="hv12_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 1311.1056,697.77464 h -15.2 l 7.52,-13.28003 z m -15.2,-26.40003 h 15.2 l -7.68,13.12 z"
               className={clshv12_body} />
            <ellipse
               style={{
                  fill: '#fefefe',
                  fillOpacity: 0,
                  stroke: '#000405',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none'
               }}
               id="path9-7-0-3-8-8-2-4-8-2-3"
               cx="1303.4402"
               cy="684.57251"
               rx="3.7180016"
               ry="3.7468233" />
            <text
               id="hv12_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-4-5-0-4-6-1)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(327.48521,-66.433422)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan299">HV-12</tspan></text>
            <path
               id="hv09_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 1311.2664,638.02074 h -15.2 l 7.52,-13.28003 z m -15.2,-26.40003 h 15.2 l -7.68,13.12 z"
               className={clshv09_body} />
            <ellipse
               style={{
                  fill: '#fefefe',
                  fillOpacity: 0,
                  stroke: '#000405',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none'
               }}
               id="path9-7-0-3-8-8-2-4-8-2-4"
               cx="1303.6011"
               cy="624.81866"
               rx="3.7180016"
               ry="3.7468233" />
            <text
               id="hv09_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-4-5-0-4-6-82)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(368.21224,-123.02441)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan300">HV-09</tspan></text>
            <path
               id="hv10_body"
               style={{
                  fill: '#f7f7f7',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1,
                  fillOpacity: 1
               }}
               d="m 1289.9181,638.02464 h -15.2 l 7.52,-13.28003 z m -15.2,-26.40003 h 15.2 l -7.68,13.12 z"
               className={clshv10_body} />
            <ellipse
               style={{
                  fill: '#fefefe',
                  fillOpacity: 0,
                  stroke: '#000405',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none'
               }}
               id="path9-7-0-3-8-8-2-4-8-2-9"
               cx="1282.2527"
               cy="624.82257"
               rx="3.7180016"
               ry="3.7468233" />
            <text
               id="hv10_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-4-5-0-4-6-17)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(304.51554,-123.48887)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan301">HV-10</tspan></text>
            <path
               id="hv13_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 1399.0458,654.38363 v 15.2 l -13.28,-7.52 z m -26.4,15.2 v -15.2 l 13.12,7.68 z"
               className={clshv13_body} />
            <ellipse
               style={{
                  fill: '#fefefe',
                  fillOpacity: 0,
                  stroke: '#000405',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none'
               }}
               id="path9-7-0-3-8-8-2-4-8-2-8"
               cx="-662.04895"
               cy="1385.8436"
               rx="3.7180016"
               ry="3.7468233"
               transform="rotate(-90)" />
            <text
               id="hv13_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-4-5-0-4-6-3)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(431.23521,-70.433422)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan302">HV-13</tspan></text>
            <path
               id="hv10_line_in"
               d="M 1282.7072,601.06406 V 611.3353"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clshv10_line_in} />
            <path
               id="hv10_line_in-1"
               d="m 1303.6419,638.25078 v 33.10804"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.474431,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clshv09_line_out} />
            <path
               id="hv11_line_in_2"
               d="m 1351.4163,586.72653 v 60.66118"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.474431,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clshv11_line_in_2} />
            <path
               id="hv10_line_in-1-2"
               d="m 1372.2325,662.3561 h -68.432"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.474431,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clshv13_line_in} />
            <path
               id="hv11_line_in_1"
               d="M 1351.3985,647.68722 H 1303.965"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.473265,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clshv11_line_in_1} />
            <text
               id="mv04_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-4-5-0-4-9-8)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(212.9406,1.4408577)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan303">MV-04</tspan></text>
            <g
               id="grp_MV04"
               transform="rotate(-90,573.74638,564.77827)">
               <g
                  id="g3"
                  transform="translate(68.874997,1.3749999)">
                  <path
                     id="path1144-1-60-0"
                     d="m 339.24484,1160.4817 h 9.44"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     id="path3073-0-4"
                     cx="-333.33621"
                     cy="1160.4735"
                     rx="6.0562205"
                     ry="6.1990557"
                     transform="scale(-1,1)" />
                  <text
                     id="text3073-2-4"
                     style={{
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        fontWeight: 'normal',
                        fontStretch: 'normal',
                        fontSize: '9.33333px',
                        fontFamily: 'Calibri',
                        whiteSpace: 'pre',
                        shapeInside: 'url(#rect3073-00-4)',
                        display: 'inline',
                        fill: '#009900',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     transform="rotate(90,65.372689,1042.2891)"><tspan
                        x="179.62891"
                        y="777.30729"
                        id="tspan305"><tspan
                           style={{
                              fill: '#000000'
                           }}
                           id="tspan304">M</tspan></tspan></text>
               </g>
               <g
                  id="g24">
                  <path
                     style={{
                        fill: '#ffffff',
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }}
                     d="m 434.7705,1169.4251 -13.28,-7.5201 13.28,-7.52 z"
                     id="mv04_recirculate"
                     className={clsmv04_recirculate} />
                  <path
                     id="mv04_treatedwater"
                     d="m 429.0104,1148.625 h -15.04 l 7.5201,13.28 z"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }}
                     className={clsmv04_treatedwater} />
                  <path
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }}
                     d="m 413.9704,1175.1849 h 15.04 l -7.5199,-13.2799 z"
                     id="mv04_common"
                     className={clsmv04_common} />
                  <ellipse
                     style={{
                        fill: '#fefefe',
                        fillOpacity: 0,
                        stroke: '#000405',
                        strokeWidth: 0.5,
                        strokeDasharray: 'none'
                     }}
                     id="path9-7-0-3-8-8-2-4-8-5-6"
                     cx="1161.9016"
                     cy="421.66315"
                     rx="3.7180016"
                     ry="3.7468233"
                     transform="matrix(0,1,1,0,0,0)" />
               </g>
            </g>
            <path
               id="p09_line_in"
               d="m 681.32663,759.61124 v 61.8136"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={p09_line_in} />
            <g
               id="grp_P08"
               transform="rotate(-90,573.74638,564.77827)">
               <g
                  id="g3073-5-9-7-3-8-5"
                  transform="matrix(0,1,1,0,-385.32498,505.06012)">
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.587747,
                        strokeDasharray: 'none'
                     }}
                     id="p08_body"
                     cx="167.00314"
                     cy="780.85254"
                     rx="15.983689"
                     ry="16.26936"
                     className={clsp08_body} />
                  <path
                     id="path1134-9-9-0-3-4-7-7"
                     d="m 153.1858,773.24334 13.7612,23.61176 13.76117,-23.61176"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.497623,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
               </g>
               <g
                  id="g5"
                  transform="translate(3.4999998,-2.4999999)">
                  <path
                     id="path1144-1-7-4-3-8-5-4"
                     d="m 393.75889,700.34932 v -9.44"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     id="path3073-21-1-7-5-0-97"
                     cx="706.25793"
                     cy="393.75073"
                     rx="6.0562205"
                     ry="6.1990557"
                     transform="matrix(0,1,1,0,0,0)" />
                  <text
                     id="text3073-7-0-8-4-7-18"
                     style={{
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        fontWeight: 'normal',
                        fontStretch: 'normal',
                        fontSize: '9.33333px',
                        fontFamily: 'Calibri',
                        whiteSpace: 'pre',
                        shapeInside: 'url(#rect3073-9-7-1-9-7-9)',
                        display: 'inline',
                        fill: '#009900',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     transform="matrix(0,-1,-1,0,1168.1849,889.92352)"><tspan
                        x="179.62891"
                        y="777.30729"
                        id="tspan307"><tspan
                           style={{
                              fill: '#000000'
                           }}
                           id="tspan306">M</tspan></tspan></text>
               </g>
            </g>
            <text
               id="p08_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-9-7-6-1-0)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-272.8318,0.53994297)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan308">P-08</tspan></text>
            <path
               id="p08_line_out"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="M 680.75594,707.44404 H 389.16187 m -0.1487,49.7583 v 19.481 m 0.0543,4.5416 v 22.9911 m 291.90505,-96.7488 v 7.13136 m 0.0205,4.24755 v 7.80097 M 681.09938,714.6276 c 3.3678,0.36419 2.8813,4.12704 0,4.20228 m -292.01321,58.07326 c 3.36777,0.3642 2.88126,4.1271 0,4.2023 m -0.0213,-28.131 c 3.36777,0.3642 2.88126,4.127 0,4.2023 M 388.91394,707.44351 l 0.20018,45.52662"
               className={clsp08_line_out} />
            <path
               id="mv04_treatedwater_line_out"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="M 355.91804,754.92464 h 43.13737          m 0.16269,-38.00647 v 37.95667          m 711.3125,-37.84855 v 28.73425          M 399.1799,716.83099 h 758.0587"
               className={clsmv04_treatedwater_line_out} />
            <path
               id="hv19_line_out"
               d="M 402.68626,804.50654 H 356.003"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clshv19_line_out} />
            <path
               id="hv14_body"
               style={{
                  fill: '#000000',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 1118.1494,772.23984 h -15.2 l 7.52,-13.28 z m -15.2,-26.40002 h 15.2 l -7.68,13.12002 z"
               className={clshv14_body} />
            <ellipse
               style={{
                  fill: '#fefefe',
                  fillOpacity: 0,
                  stroke: '#000405',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none'
               }}
               id="path9-7-0-3-8-8-2-4-2"
               cx="1110.484"
               cy="759.03766"
               rx="3.7180016"
               ry="3.7468233" />
            <text
               id="hv14_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-4-5-0-6)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(155.03104,31.656598)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan309">HV-14</tspan></text>
            <text
               id="pc02_label-3-5"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-3-4-2-3-4-3-0)',
                  shapePadding: 2.10135,
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(125.28989,-6.1763959)"
               className={clspagetext}
               x="18.062819"
               y="0"><tspan
                  x="964.95801"
                  y="753.96287"
                  id="tspan311"><tspan
                     style={{
                        textAlign: 'center',
                        textAnchor: 'middle'
                     }}
                     id="tspan310">
                  </tspan></tspan><tspan
                     x="948.70869"
                     y="765.62956"
                     id="tspan313"><tspan
                        style={{
                           textAlign: 'center',
                           textAnchor: 'middle'
                        }}
                        id="tspan312">Sample
                  </tspan></tspan><tspan
                     x="953.53868"
                     y="777.29624"
                     id="tspan315"><tspan
                        style={{
                           textAlign: 'center',
                           textAnchor: 'middle'
                        }}
                        id="tspan314">Point</tspan></tspan></text>
            <text
               id="pc02_label-3-5-07"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-3-4-2-3-4-3-0-8)',
                  shapePadding: 2.10135,
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-522.36975,-330.69011)"
               className={clspagetext}
               x="18.062819"
               y="0"><tspan
                  x="964.95801"
                  y="753.96287"
                  id="tspan317"><tspan
                     style={{
                        textAlign: 'center',
                        textAnchor: 'middle'
                     }}
                     id="tspan316">
                  </tspan></tspan><tspan
                     x="948.70869"
                     y="765.62956"
                     id="tspan319"><tspan
                        style={{
                           textAlign: 'center',
                           textAnchor: 'middle'
                        }}
                        id="tspan318">Sample
                  </tspan></tspan><tspan
                     x="953.53868"
                     y="777.29624"
                     id="tspan321"><tspan
                        style={{
                           textAlign: 'center',
                           textAnchor: 'middle'
                        }}
                        id="tspan320">Point</tspan></tspan></text>
            <path
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 1217.7996,658.80156 c 3.3678,0.36419 2.8813,4.12704 0,4.20228"
               id="path193"
               className={clsp07_line_out} />
            <path
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 815.2181,714.79111 c 3.3678,0.36419 2.8813,4.12704 0,4.20228"
               id="path192"
               className={clsp07_line_out} />
            <path
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="M 1217.8071,663.13427 V 691.6699"
               id="path191"
               className={clsp07_line_out} />
            <path
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 1217.7971,579.38907 v 79.29658"
               id="path190"
               className={clsp07_line_out} />
            <path
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.496,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 1217.8464,579.30657 h 55.5342"
               id="path189"
               className={clsp07_line_out} />
            <path
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="M 815.33573,691.77042 H 1217.6443"
               id="path188"
               className={clsp07_line_out} />
            <path
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.500264,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="M 815.2181,719.21382 V 868.04308"
               id="path187"
               className={clsp07_line_out} />
            <path
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 815.19308,691.85381 v 22.90416"
               id="hv22_line_out"
               className={clsp07_line_out} />
            <g
               id="grp_P07"
               transform="rotate(-90,573.74638,564.77827)">
               <g
                  id="g3073-5-9-7-3-8-4"
                  transform="matrix(1,0,0,-1,160.05951,1531.9739)">
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.587747,
                        strokeDasharray: 'none'
                     }}
                     id="p07_body"
                     cx="110.08105"
                     cy="806.66193"
                     rx="15.983689"
                     ry="16.26936"
                     className={clsp07_body} />
                  <path
                     id="path1134-9-9-0-3-4-7-3"
                     d="M 123.8984,814.27114 110.1372,790.65938 96.376027,814.27114"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.497623,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
               </g>
               <g
                  id="g3074-7-5-4-6-2-1"
                  transform="matrix(1,0,0,-1,104.71069,1518.076)">
                  <path
                     id="path1144-1-7-4-3-8-5-65"
                     d="m 191.37561,793.45873 h -9.44"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     id="path3073-21-1-7-5-0-6"
                     cx="197.28423"
                     cy="793.45056"
                     rx="6.0562205"
                     ry="6.1990557" />
                  <text
                     id="text3073-7-0-8-4-7-2"
                     style={{
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        fontWeight: 'normal',
                        fontStretch: 'normal',
                        fontSize: '9.33333px',
                        fontFamily: 'Calibri',
                        whiteSpace: 'pre',
                        shapeInside: 'url(#rect3073-9-7-1-9-7-0)',
                        display: 'inline',
                        fill: '#009900',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     transform="rotate(90,180.90494,790.79846)"><tspan
                        x="179.62891"
                        y="777.30729"
                        id="tspan323"><tspan
                           style={{
                              fill: '#000000'
                           }}
                           id="tspan322">M</tspan></tspan></text>
               </g>
            </g>
            <text
               id="p07_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-9-7-6-1-21)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-222.26252,119.24688)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan324">P-07</tspan></text>
            <g
               id="grp_P11"
               transform="rotate(-90,573.74638,564.77827)">
               <g
                  id="g3073-5-9-7-3-8-5-8"
                  transform="matrix(0,1,1,0,-521.16431,46.21755)">
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.587747,
                        strokeDasharray: 'none'
                     }}
                     id="p11_body"
                     cx="167.00314"
                     cy="780.85254"
                     rx="15.983689"
                     ry="16.26936"
                     className={clsp11_body} />
                  <path
                     id="path1134-9-9-0-3-4-7-7-8"
                     d="m 153.1858,773.24334 13.7612,23.61176 13.76117,-23.61176"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.497623,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
               </g>
               <g
                  id="g5-3"
                  transform="translate(-132.33933,-461.34257)">
                  <path
                     id="path1144-1-7-4-3-8-5-4-7"
                     d="m 393.75889,700.34932 v -9.44"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     id="path3073-21-1-7-5-0-97-2"
                     cx="706.25793"
                     cy="393.75073"
                     rx="6.0562205"
                     ry="6.1990557"
                     transform="matrix(0,1,1,0,0,0)" />
                  <text
                     id="text3073-7-0-8-4-7-18-6"
                     style={{
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        fontWeight: 'normal',
                        fontStretch: 'normal',
                        fontSize: '9.33333px',
                        fontFamily: 'Calibri',
                        whiteSpace: 'pre',
                        shapeInside: 'url(#rect3073-9-7-1-9-7-9-6)',
                        display: 'inline',
                        fill: '#009900',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     transform="matrix(0,-1,-1,0,1168.1849,889.92352)"><tspan
                        x="179.62891"
                        y="777.30729"
                        id="tspan326"><tspan
                           style={{
                              fill: '#000000'
                           }}
                           id="tspan325">M</tspan></tspan></text>
               </g>
            </g>
            <text
               id="p11_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-9-7-6-1-0-8)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-731.274,137.61449)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan327">P-11</tspan></text>
            <g
               id="grp_P10"
               transform="rotate(-90,573.74638,564.77827)">
               <g
                  id="g3073-5-9-7-3-8-5-2"
                  transform="matrix(0,1,1,0,-474.37941,288.49279)">
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.587747,
                        strokeDasharray: 'none'
                     }}
                     id="p10_body"
                     cx="167.00314"
                     cy="780.85254"
                     rx="15.983689"
                     ry="16.26936"
                     className={clsp10_body} />
                  <path
                     id="path1134-9-9-0-3-4-7-7-9"
                     d="m 153.1858,773.24334 13.7612,23.61176 13.76117,-23.61176"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.497623,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
               </g>
               <g
                  id="g5-5"
                  transform="translate(-85.554428,-219.06733)">
                  <path
                     id="path1144-1-7-4-3-8-5-4-6"
                     d="m 393.75889,700.34932 v -9.44"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     id="path3073-21-1-7-5-0-97-3"
                     cx="706.25793"
                     cy="393.75073"
                     rx="6.0562205"
                     ry="6.1990557"
                     transform="matrix(0,1,1,0,0,0)" />
                  <text
                     id="text3073-7-0-8-4-7-18-66"
                     style={{
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        fontWeight: 'normal',
                        fontStretch: 'normal',
                        fontSize: '9.33333px',
                        fontFamily: 'Calibri',
                        whiteSpace: 'pre',
                        shapeInside: 'url(#rect3073-9-7-1-9-7-9-4)',
                        display: 'inline',
                        fill: '#009900',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.56,
                        strokeDasharray: 'none'
                     }}
                     transform="matrix(0,-1,-1,0,1168.1849,889.92352)"><tspan
                        x="179.62891"
                        y="777.30729"
                        id="tspan329"><tspan
                           style={{
                              fill: '#000000'
                           }}
                           id="tspan328">M</tspan></tspan></text>
               </g>
            </g>
            <text
               id="p10_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-9-7-6-1-0-2)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-490.04851,90.955641)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan330">P-10</tspan></text>
            <path
               id="hv17_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 416.22291,895.50344 v 15.2 l -13.28,-7.52 z m -26.4,15.2 v -15.2 l 13.12,7.68 z"
               className={clshv17_body} />
            <ellipse
               style={{
                  fill: '#fefefe',
                  fillOpacity: 0,
                  stroke: '#000405',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none'
               }}
               id="path9-7-0-3-8-8-7-9-6-6-50"
               cx="-902.92413"
               cy="403.10233"
               rx="3.7180016"
               ry="3.7468233"
               transform="rotate(-90)" />
            <text
               id="hv17_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-4-4-1-2-3-0)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-552.61638,168.3588)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan331">HV-17</tspan></text>
            <path
               id="hv19_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 428.58688,796.75124 v 15.2001 l -13.28,-7.52 z m -26.4,15.2001 v -15.2001 l 13.12,7.6801 z"
               className={clshv19_body} />
            <ellipse
               style={{
                  fill: '#fefefe',
                  fillOpacity: 0,
                  stroke: '#000405',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none'
               }}
               id="path9-7-0-3-8-8-7-9-6-6-3"
               cx="-804.17206"
               cy="415.46628"
               rx="3.7180016"
               ry="3.7468233"
               transform="rotate(-90)" />
            <text
               id="hv19_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-4-4-1-2-3-6)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-540.77018,68.712363)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan332">HV-19</tspan></text>
            <path
               id="hv20_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 472.05755,794.33184 h -15.20001 l 7.51999,-13.2801 z m -15.20001,-26.4001 h 15.20001 l -7.68002,13.12 z"
               className={clshv20_body} />
            <ellipse
               style={{
                  fill: '#fefefe',
                  fillOpacity: 0,
                  stroke: '#000405',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none'
               }}
               id="path9-7-0-3-8-8-7-9-7"
               cx="464.63681"
               cy="781.21124"
               rx="3.7180016"
               ry="3.7468233" />
            <text
               id="hv20_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-4-4-1-6)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-508.96641,31.502098)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan333">HV-20</tspan></text>
            <path
               id="hv18_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 471.81149,889.35784 h -15.20001 l 7.51999,-13.2801 z m -15.20001,-26.4001 h 15.20001 l -7.68002,13.12 z"
               className={clshv18_body} />
            <ellipse
               style={{
                  fill: '#fefefe',
                  fillOpacity: 0,
                  stroke: '#000405',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none'
               }}
               id="path9-7-0-3-8-8-7-9-65"
               cx="464.39075"
               cy="876.23724"
               rx="3.7180016"
               ry="3.7468233" />
            <text
               id="hv18_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-4-4-1-0)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-509.15963,127.84873)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan334">HV-18</tspan></text>
            <path
               id="hv15_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 355.6806,747.47368 v 15.19996 l -13.28,-7.5199 z m -26.4,15.19996 v -15.19996 l 13.12,7.68006 z"
               className={clshv15_body} />
            <ellipse
               style={{
                  fill: '#fefefe',
                  fillOpacity: 0,
                  stroke: '#000405',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none'
               }}
               id="path9-7-0-3-8-8-7-9-6-6-50-2"
               cx="-754.89441"
               cy="342.56"
               rx="3.7180016"
               ry="3.7468233"
               transform="rotate(-90)" />
            <text
               id="hv15_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-4-4-1-2-3-0-8)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-612.66666,18.981032)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan335">HV-15</tspan></text>
            <path
               id="hv16_body"
               style={{
                  fill: '#000000',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 383.91809,741.77464 h -15.20001 l 7.51999,-13.28003 z m -15.20001,-26.40003 h 15.20001 l -7.68002,13.12 z"
               className={clshv16_body} />
            <ellipse
               style={{
                  fill: '#fefefe',
                  fillOpacity: 0,
                  stroke: '#000405',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none'
               }}
               id="path9-7-0-3-8-8-7-0"
               cx="376.25278"
               cy="728.57251"
               rx="3.7180016"
               ry="3.7468233" />
            <text
               id="hv16_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-4-4-7)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-596.3707,-20.170898)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan336">HV-16</tspan></text>
            <ellipse
               style={{
                  fill: '#fefefe',
                  fillOpacity: 0,
                  stroke: '#000405',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none'
               }}
               id="path9-7-0-0-8"
               cx="-953.38696"
               cy="-447.785"
               rx="3.7180016"
               ry="3.7468233"
               transform="scale(-1)" />
            <path
               id="ls07_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.529279,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="M 287.47164,904.47651 287.12176,787.87029 M 270.776,771.15232 h 32.79532 M 287.3912,754.55625 c 9.16655,-3e-5 16.59752,7.39255 16.59752,16.51177 0,9.11922 -7.43097,16.5118 -16.59752,16.51177 -9.16654,2e-5 -16.5975,-7.39256 -16.5975,-16.51177 0,-9.11921 7.43096,-16.51179 16.5975,-16.51177 z"
               className={clsls07_body} />
            <text
               id="ls07_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-8-8-6-2-7-7)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               transform="translate(-667.30368,15.809605)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan337">LS07</tspan></text>
            <g
               id="grp_AE03b"
               transform="rotate(-90,173.67122,1132.5749)">
               <path
                  style={{
                     fill: '#ffffff',
                     stroke: '#000000',
                     strokeWidth: 0.449978,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }}
                  d="m 584.29321,1465.152 a 16.51177,16.597471 0 0 1 -16.51177,16.5975 16.51177,16.597471 0 0 1 -16.51177,-16.5975 16.51177,16.597471 0 0 1 16.51177,-16.5975 16.51177,16.597471 0 0 1 16.51177,16.5975 z"
                  id="ae03b_ph_body"
                  className={clsae03b_ph_body} />
               <path
                  style={{
                     fill: '#ffffff',
                     stroke: '#000000',
                     strokeWidth: 0.449978,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }}
                  d="m 567.69714,1448.5368 v 32.7953"
                  id="path15-0" />
            </g>
            <text
               id="ae03b_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-8-8-5-9-4-1-0)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-417.66482,-23.562704)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan338">AE03B pH</tspan></text>
            <text
               id="ae03b_ph_value"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-5-6-1-1-2-1-7)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-417.49713,-11.566388)"
               className={clsshowsensorla}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan339">{ae03b_1}</tspan></text>
            <g
               id="grp_AE03a"
               transform="rotate(-90,179.39372,1463.1756)">
               <path
                  style={{
                     fill: '#ffffff',
                     stroke: '#000000',
                     strokeWidth: 0.449978,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }}
                  d="m 898.7932,1826.902 a 16.51177,16.597471 0 0 1 -16.51177,16.5975 16.51177,16.597471 0 0 1 -16.51177,-16.5975 16.51177,16.597471 0 0 1 16.51177,-16.5975 16.51177,16.597471 0 0 1 16.51177,16.5975 z"
                  id="ae03a_cl_body"
                  className={clsae03a_cl_body} />
               <path
                  style={{
                     fill: '#ffffff',
                     stroke: '#000000',
                     strokeWidth: 0.449978,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }}
                  d="m 882.19713,1810.2868 v 32.7953"
                  id="path15-7" />
            </g>
            <text
               id="ae03a_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-8-8-5-9-4-1-9)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-379.65257,6.5549477)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan340">AE03A Cl</tspan></text>
            <text
               id="ae03a_cl_value"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-5-6-1-1-2-1-8)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-380.91977,17.78807)"
               className={clsshowsensorla}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan341">{ae03a_1}</tspan></text>
            <text
               id="pc02_label-3-5-0"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-3-4-2-3-4-3-0-9)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-14.387855,-66.223692)"
               className={clspagetext}
               x="18.062819"
               y="0"><tspan
                  x="960.52257"
                  y="751.86131"
                  id="tspan343"><tspan
                     style={{
                        textAlign: 'center',
                        textAnchor: 'middle'
                     }}
                     id="tspan342">Pilot Pressure Line</tspan></tspan></text>
            <g
               id="grp_T09">
               <path
                  id="t09_body"
                  d="m 641.37627,773.40984 v 55.36 h 44.16003 v -55.36 z"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }}
                  className={clst09_body} />
               <text
                  id="pc02_label-3-5-2"
                  style={{
                     fontStyle: 'normal',
                     fontVariant: 'normal',
                     fontWeight: 'normal',
                     fontStretch: 'normal',
                     fontSize: '9.33333px',
                     fontFamily: 'sans-serif',
                     fontVariantLigatures: 'normal',
                     fontVariantCaps: 'normal',
                     fontVariantNumeric: 'normal',
                     fontVariantEastAsian: 'normal',
                     textAlign: 'center',
                     whiteSpace: 'pre',
                     shapeInside: 'url(#rect3061-3-4-2-3-4-3-0-4)',
                     display: 'inline',
                     fill: '#000000',
                     fillOpacity: 1,
                     stroke: '#000405',
                     strokeWidth: 0.56,
                     strokeDasharray: 'none'
                  }}
                  transform="translate(-303.78815,30.903321)"
                  className={clspagetext}
                  x="36.902657"
                  y="0"><tspan
                     x="946.21663"
                     y="751.86131"
                     id="tspan344">Chlorine
                  </tspan><tspan
                     x="949.30129"
                     y="763.52799"
                     id="tspan345">Dosing</tspan></text>
            </g>
            <text
               id="pc02_label-3-5-5"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-3-4-2-3-4-3-0-5)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-264.2145,148.41183)"
               className={clspagetext}
               x="18.062819"
               y="0"><tspan
                  x="961.44309"
                  y="751.86131"
                  id="tspan347"><tspan
                     style={{
                        textAlign: 'center',
                        textAnchor: 'middle'
                     }}
                     id="tspan346">Plant washdown</tspan></tspan></text>
            <text
               id="t09_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-9-7-6-1-0-28)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-290.45876,87.316383)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan348">T-09</tspan></text>
            <text
               id="cv02_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-9-7-6-3)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-523.63211,-72.780842)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan349">CV-02</tspan></text>
            <text
               id="cv01_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-9-7-6-3-7)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-601.79204,-55.780852)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan350">CV-01</tspan></text>
            <path
               id="hv15_line_out"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 308.4281,754.99312 h 20.94345 m -20.97176,0.0496 v 24.14724"
               className={clshv15_line_out} />
            <path
               id="tk08_line_in"
               d="m 308.39859,779.57655 v 19.86512"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clstk08_line_in} />
            <path
               id="hv20_line_out"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 308.6672,779.04964 h 111.87233 m 0.12177,-44.24997 h 43.7097 m 0.0453,0.0502 v 32.79997 m -43.84,-32.85423 v 44.21303 m 105.93271,-18.4688 h -61.67796 m 24.81346,-22.00995 h -24.66692"
               className={clshv20_line_out} />
            <path
               id="hv16_line_out"
               d="m 376.30485,742.00578 v 12.77316"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clshv16_line_out} />
            <path
               id="hv16_line_in"
               d="m 376.1995,704.30353 v 10.88374"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clshv16_line_in} />
            <path
               id="p10_line_out"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 428.78902,804.42334 h 35.31635 m 0.27739,-9.847 v 20.8835"
               className={clsp10_line_out} />
            <path
               id="hv21_line_in"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.497089,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 621.51607,868.43914 h 95.49074 m -95.51664,0.2312 v 27.2361 m -0.12547,0.063 H 464.25603"
               className={clsp07_line_in} />
            <g
               id="crv02_body"
               transform="rotate(-90,550.30137,572.93209)">
               <path
                  id="path1996"
                  d="m 454.84476,470.39819 h 15.20001 l -15.20001,-26.4 h 15.20001"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
               <ellipse
                  style={{
                     fill: '#ffffff',
                     fillOpacity: 0,
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeDasharray: 'none'
                  }}
                  id="path3"
                  cx="469.37497"
                  cy="469.06247"
                  rx="1.3749999"
                  ry="1.3125" />
               <path
                  style={{
                     fill: '#000000',
                     fillOpacity: 1,
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeDasharray: 'none'
                  }}
                  d="m 461.91223,451.77808 -3.65625,2.10938 -3.26562,-9.625 z"
                  id="path16" />
            </g>
            <g
               id="crv01_body"
               transform="translate(-86.029196,233.53806)">
               <path
                  id="path1996-9"
                  d="m 454.84476,470.39819 h 15.20001 l -15.20001,-26.4 h 15.20001"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
               <ellipse
                  style={{
                     fill: '#ffffff',
                     fillOpacity: 0,
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeDasharray: 'none'
                  }}
                  id="path3-5"
                  cx="469.37497"
                  cy="469.06247"
                  rx="1.3749999"
                  ry="1.3125" />
               <path
                  style={{
                     fill: '#000000',
                     fillOpacity: 1,
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeDasharray: 'none'
                  }}
                  d="m 461.91223,451.77808 -3.65625,2.10938 -3.26562,-9.625 z"
                  id="path16-6" />
            </g>
            <text
               id="text1"
               style={{
                  textAlign: 'start',
                  writingMode: 'lr-tb',
                  direction: 'ltr',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect2)',
                  display: 'inline',
                  fill: '#000000'
               }} />
            <text
               id="ae01a_orp_ph_value-2"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  textAlign: 'center',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-5-6-1-4)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-222.56918,-414.8826)"
               className={clsshowsensor}
               x="62.072571"
               y="0"><tspan
                  x="963.33723"
                  y="751.86131"
                  id="tspan351">{ae01a_orp_ph_2}</tspan></text>
            <text
               id="ae01a_orp_ph_value-2-1"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  textAlign: 'center',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-5-6-1-4-1)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-222.56918,-403.23109)"
               className={clsshowsensor}
               x="62.072571"
               y="0"><tspan
                  x="963.33723"
                  y="751.86131"
                  id="tspan352">{ae01a_orp_ph_3}</tspan></text>
            <text
               id="ae01b_orp_ph_value-2"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  textAlign: 'center',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-5-6-1-6-6)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-81.67945,-421.54325)"
               className={clsshowsensor}
               x="62.177387"
               y="0"><tspan
                  x="966.44754"
                  y="751.86131"
                  id="tspan353">{ae01b_orp_ph_2}</tspan></text>
            <text
               id="ae01b_orp_ph_value-2-5"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  textAlign: 'center',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-5-6-1-6-6-1)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-81.67945,-409.51208)"
               className={clsshowsensor}
               x="62.177387"
               y="0"><tspan
                  x="966.44754"
                  y="751.86131"
                  id="tspan354">{ae01b_orp_ph_3}</tspan></text>
            <text
               id="ae01a_do_value-7"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  textAlign: 'center',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-5-6-1-1-8)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-324.06162,-178.96368)"
               className={clsshowsensor}
               x="51.253563"
               y="0"><tspan
                  x="982.49159"
                  y="751.86131"
                  id="tspan355">{b02_1}</tspan></text>
            <text
               id="ae01a_do_value-7-3"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  textAlign: 'center',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-5-6-1-1-8-3)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-644.7748,-409.04638)"
               className={clsshowsensor}
               x="51.253563"
               y="0"><tspan
                  x="979.14559"
                  y="751.86131"
                  id="tspan356">{fcv01_1}</tspan></text>
            <text
               id="ft01_value-4"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-5-6-3)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-363.80459,-436.18292)"
               className={clsshowsensor}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan357">{ls01_1}</tspan></text>
            <text
               id="ft01_value-4-26"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-5-6-3-8)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-333.80799,-552.40925)"
               className={clsshowsensorla}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan358">{p03_1}</tspan></text>
            <text
               style={{
                  textAlign: 'start',
                  writingMode: 'lr-tb',
                  direction: 'ltr',
                  textAnchor: 'start',
                  fill: '#000000'
               }}
               x="586.69727"
               y="324.44864"
               id="text106"><tspan
                  id="tspan106" /></text>
            <text
               id="ft01_value-4-3"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-5-6-3-3)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-32.596404,-350.06532)"
               className={clsshowsensor}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan359">{ls02_1}</tspan></text>
            <text
               id="ft01_value-4-8"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-5-6-3-6)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(66.393837,-348.57882)"
               className={clsshowsensor}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan360">{ls03_1}</tspan></text>
            <text
               id="ft01_value-4-2"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-5-6-3-7)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(243.62967,-401.10161)"
               className={clsshowsensor}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan361">{ls05_1}</tspan></text>
            <text
               id="ft01_value-4-0-2"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-5-6-3-5-1)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-654.78122,-6.1531979)"
               className={clsshowsensor}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan362">{ls07_1}</tspan></text>
            <path
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: '0.183463px',
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 4,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 491.38539,1014.9083 h 599.79041 c 10.3559,0 18.7325,-14.1062 18.7325,-31.54532 0,0 0,0 0,0 v -5.8329 c 0,-15.11788 -7.2809,-27.43835 -16.2937,-27.43835 0,0 0,0 0,0 H 491.38539 c -8.97741,0 -16.29366,12.32047 -16.29366,27.43835 0,0 0,0 0,0 v 9.93973 c 0,15.17739 7.31625,27.43849 16.29366,27.43849 z"
               id="path2" />
            <text
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 700,
                  fontSize: '11.4142px',
                  lineHeight: '125%',
                  fontFamily: 'Calibri',
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  textAnchor: 'start',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: 'none',
                  strokeWidth: 0.997958
               }}
               x="498.50278"
               y="973.79559"
               id="text3"
               transform="scale(1.0009208,0.99908003)"
               className={clslegendlabel}><tspan
                  x="498.50278"
                  y="973.79559"
                  id="tspan3-2"
                  style={{
                     strokeWidth: 0.997958
                  }}>PAR Quantum Sensor - Outside</tspan></text>
            <text
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 700,
                  fontSize: '11.4142px',
                  lineHeight: '125%',
                  fontFamily: 'Calibri',
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  textAnchor: 'start',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: 'none',
                  strokeWidth: 0.997958
               }}
               x="723.992"
               y="973.79559"
               id="text5"
               transform="scale(1.0009208,0.99908003)"
               className={clslegendlabel}><tspan
                  x="723.992"
                  y="973.79559"
                  id="tspan162"
                  style={{
                     fontStyle: 'normal',
                     fontVariant: 'normal',
                     fontWeight: 700,
                     fontSize: '11.4142px',
                     fontFamily: 'Calibri',
                     fill: '#000000',
                     strokeWidth: 0.997958
                  }}>PAR Quantum Sensor - Inside</tspan></text>
            <text
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 700,
                  fontSize: '11.4142px',
                  lineHeight: '125%',
                  fontFamily: 'Calibri',
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  textAnchor: 'start',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: 'none',
                  strokeWidth: 0.997958
               }}
               x="941.28284"
               y="973.34973"
               id="text13"
               transform="scale(1.0009208,0.99908003)"
               className={clslegendlabel}><tspan
                  x="941.28284"
                  y="973.34973"
                  id="tspan13-2"
                  style={{
                     strokeWidth: 0.997958
                  }}>System Power Consumption</tspan></text>
            <text
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 400,
                  fontSize: '10.4785px',
                  lineHeight: '125%',
                  fontFamily: 'Calibri',
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  textAnchor: 'start',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: 'none',
                  strokeWidth: 0.997958
               }}
               id="text17"
               transform="scale(1.0009208,0.99908004)"
               className={clslegendvalue}
               x="538.01526"
               y="994.78271"><tspan
                  x="570.01526"
                  y="994.99988"
                  id="tspan17-4"
                  style={{
                     strokeWidth: 0.997958
                  }}>{par02_ppfd}</tspan><tspan
                  x="538.01526"
                  y="1008.098"
                  id="tspan166"
                  style={{
                     strokeWidth: 0.997958
                  }} /></text>
            <text
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 400,
                  fontSize: '10.4785px',
                  lineHeight: '125%',
                  fontFamily: 'Calibri',
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  textAnchor: 'start',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: 'none',
                  strokeWidth: 0.997958
               }}
               x="753.84369"
               y="994.78271"
               id="text19"
               transform="scale(1.0009208,0.99908004)"
               className={clslegendvalue}><tspan
                  x="789.84369"
                  y="994.78271"
                  id="tspan19-0"
                  style={{
                     strokeWidth: 0.997958
                  }}>{par01_ppfd}<tspan
                     style={{
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        fontWeight: 400,
                        fontSize: '10.4785px',
                        fontFamily: 'Calibri',
                        fill: '#000000',
                        strokeWidth: 0.997958
                     }}
                     id="tspan18-7" /></tspan></text>
            <text
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 400,
                  fontSize: '10.4785px',
                  lineHeight: '125%',
                  fontFamily: 'Calibri',
                  textAlign: 'start',
                  letterSpacing: '0px',
                  wordSpacing: '0px',
                  textAnchor: 'start',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: 'none',
                  strokeWidth: 0.997958
               }}
               x="958.97882"
               y="992.78088"
               id="text25"
               transform="scale(1.0009208,0.99908004)"
               className={clslegendvalue}><tspan
                  x="1005.97882"
                  y="992.78088"
                  id="tspan25-7"
                  style={{
                     strokeWidth: 0.997958
                  }}>{pwr01_powertotal}</tspan></text>
            <text
               id="ft01_value-4-26-2"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-5-6-3-8-8)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-260.1682,15.660003)"
               className={clsshowsensorla}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan363">{p08_1}</tspan></text>
            <g
               id="g4">
               <path
                  id="to_irrigation_body"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }}
                  d="m 145.2163,788.12984 -7.68,-7.68 7.68,-7.68 m 0,0 h 61.76 v 15.36 m 0,0 h -61.76"
                  className={clsto_irrigation_body} />
               <text
                  id="to_irrigation_label"
                  style={{
                     fontStyle: 'normal',
                     fontVariant: 'normal',
                     fontWeight: 'normal',
                     fontStretch: 'normal',
                     fontSize: '9.33333px',
                     fontFamily: 'sans-serif',
                     fontVariantLigatures: 'normal',
                     fontVariantCaps: 'normal',
                     fontVariantNumeric: 'normal',
                     fontVariantEastAsian: 'normal',
                     whiteSpace: 'pre',
                     shapeInside: 'url(#rect3061-9-7-6-1-0-28-8-4)',
                     display: 'inline',
                     fill: '#000000',
                     fillOpacity: 1,
                     stroke: '#000405',
                     strokeWidth: 0.56,
                     strokeDasharray: 'none'
                  }}
                  transform="translate(-795.64627,31.314926)"><tspan
                     x="943.96875"
                     y="751.86131"
                     id="tspan364">To Irrigation</tspan></text>
            </g>
            <g
               id="g10">
               <path
                  id="path449"
                  d="m 536.57628,464.28987 2.08002,2.88 2.07998,-2.88"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
               <path
                  id="path450"
                  d="m 558.01628,464.28987 2.08002,2.88 2.08002,-2.88"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
               <path
                  id="path451"
                  d="m 577.37627,464.28987 2.08002,2.88 2.23998,-2.88"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
            </g>
            <path
               id="pc01_line_out"
               style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 0.5,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 544.49361,351.48122 v 71.16308 m -24.87732,-71.15442 h 24.79999"
               className={clspc01_line_out} />
            <text
               id="pc02_label-3-5-0-4"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-3-4-2-3-4-3-0-9-6)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-235.10363,-111.61173)"
               className={clspagetext}
               x="18.062819"
               y="0"><tspan
                  x="962.23057"
                  y="751.86131"
                  id="tspan366"><tspan
                     style={{
                        textAlign: 'center',
                        textAnchor: 'middle'
                     }}
                     id="tspan365">Recirculation Line</tspan></tspan></text>
            <text
               id="pc02_label-3-5-0-7"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-3-4-2-3-4-3-0-9-4)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-234.26309,-78.410379)"
               className={clspagetext}
               x="18.062819"
               y="0"><tspan
                  x="968.79655"
                  y="751.86131"
                  id="tspan368"><tspan
                     style={{
                        textAlign: 'center',
                        textAnchor: 'middle'
                     }}
                     id="tspan367">Backwash Line</tspan></tspan></text>
            <text
               id="text2"
               style={{
                  fontSize: '16px',
                  textAlign: 'center',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3)',
                  display: 'inline',
                  fill: '#000000',
                  stroke: '#000000',
                  strokeWidth: 0.5
               }} />
            <path
               id="t04_body"
               d="M 811.92282,540.42219 V 574.759 h 90.88815 v -34.33681 z"
               style={{
                  stroke: '#000000',
                  strokeWidth: 0.346179,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               className={clst04_body}
               fill="url(#tk04fill)" />
            <path
               id="path1604-9-9-2"
               d="m 884.90989,554.30101 v -5.95312 h 0.7813 v 2.45312 h 3.0937 v -2.45312 h 0.7813 v 5.95312 h -0.7813 v -2.79687 h -3.0937 v 2.79687 z m 5.8438,0 v -5.95312 h 0.7812 v 5.25 h 2.9375 v 0.70312 z m 0,0"
               style={{
                  fill: '#000000',
                  fillOpacity: 1,
                  fillRule: 'nonzero',
                  stroke: 'none',
                  strokeWidth: 0.025391
               }}
               aria-label="HL" />
            <text
               id="t04_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  textAlign: 'center',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-3-4-7-6)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="matrix(0.8806193,0,0,0.81031764,-57.290838,-26.596488)"
               className={clspagetext}
               x="143.14221"
               y="0"><tspan
                  x="965.45528"
                  y="753.42217"
                  id="tspan370"><tspan
                     style={{
                        fontSize: '11.0488px',
                        fontFamily: 'Sans'
                     }}
                     id="tspan369">Sludge Tank
                  </tspan></tspan><tspan
                     x="985.81821"
                     y="767.23314"
                     id="tspan372"><tspan
                        style={{
                           fontSize: '11.0488px',
                           fontFamily: 'Sans'
                        }}
                        id="tspan371">T-04</tspan></tspan></text>
            <path
               id="ls04_body"
               style={{
                  fill: '#ffffff',
                  stroke: '#000000',
                  strokeWidth: 0.463976,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
               }}
               d="m 896.55296,569.06957 -0.11802,-30.33526 m -16.31309,-16.68533 h 32.7953 m -16.1801,-16.59607 a 16.597471,16.51177 0 0 1 16.5975,16.51177 16.597471,16.51177 0 0 1 -16.5975,16.51177 16.597471,16.51177 0 0 1 -16.5975,-16.51177 16.597471,16.51177 0 0 1 16.5975,-16.51177 z"
               className={clsls04_body} />
            <text
               id="ls04_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-8-8-6-6)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-58.243051,-232.08461)"><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan373">LS04</tspan></text>
            <text
               id="ft01_value-4-2-0"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-5-5-6-3-7-9-0)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-47.575336,-250.60009)"
               className={clsshowsensor}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan374">{ls04_1}</tspan></text>
            <g
               id="grp_P04"
               transform="translate(342.79344,164.60745)">
               <g
                  id="g3073-5-9-7-3"
                  transform="matrix(1,0,0,-1,350.07094,1215.9143)">
                  <ellipse
                     style={{
                        fill: '#ffffff',
                        fillOpacity: 1,
                        stroke: '#000405',
                        strokeWidth: 0.587747,
                        strokeDasharray: 'none'
                     }}
                     id="p04_body"
                     cx="167.00314"
                     cy="780.85254"
                     rx="15.983689"
                     ry="16.26936"
                     className={clsp04_body} />
                  <path
                     id="path1134-9-9-0-3-4"
                     d="m 153.1858,773.24334 13.7612,23.61176 13.76117,-23.61176"
                     style={{
                        fill: 'none',
                        stroke: '#000000',
                        strokeWidth: 0.497623,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 10,
                        strokeDasharray: 'none',
                        strokeOpacity: 1
                     }} />
               </g>
               <path
                  id="path1144-1-7-4-3-8"
                  d="m 543.01982,434.36707 h -9.44"
                  style={{
                     fill: 'none',
                     stroke: '#000000',
                     strokeWidth: 0.5,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }} />
               <ellipse
                  style={{
                     fill: '#ffffff',
                     fillOpacity: 1,
                     stroke: '#000405',
                     strokeWidth: 0.56,
                     strokeDasharray: 'none'
                  }}
                  id="path3073-21-1-7-5"
                  cx="548.92841"
                  cy="-434.37524"
                  rx="6.0562205"
                  ry="6.1990557"
                  transform="scale(1,-1)" />
               <text
                  id="text3073-7-0-8-4"
                  style={{
                     fontStyle: 'normal',
                     fontVariant: 'normal',
                     fontWeight: 'normal',
                     fontStretch: 'normal',
                     fontSize: '9.33333px',
                     fontFamily: 'Calibri',
                     whiteSpace: 'pre',
                     shapeInside: 'url(#rect3073-9-7-1-9-9)',
                     display: 'inline',
                     fill: '#009900',
                     fillOpacity: 1,
                     stroke: '#000405',
                     strokeWidth: 0.56,
                     strokeDasharray: 'none'
                  }}
                  transform="matrix(-1,0,0,1,732.59402,-340.05893)"><tspan
                     x="179.62891"
                     y="777.30729"
                     id="tspan376"><tspan
                        style={{
                           fill: '#000000'
                        }}
                        id="tspan375">M</tspan></tspan></text>
            </g>
            <text
               id="p04_label"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'sans-serif',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-9-7-6-9)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-94.860019,-141.58511)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.86131"
                  id="tspan377">P-04</tspan></text>
            <path
               style={{
                  fill: '#ffffff',
                  fillOpacity: 1,
                  stroke: '#000000',
                  strokeWidth: 0.496,
                  strokeDasharray: 'none',
                  strokeDashoffset: 0
               }}
               d="m 859.7679,583.23006 -0.10507,-8.4054 v 0"
               id="p04_line_out" />
            <path
               style={{
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000000',
                  strokeWidth: 0.290242,
                  strokeDasharray: 'none',
                  strokeDashoffset: 0,
                  strokeOpacity: 0.92
               }}
               d="m 1007.2357,641.02283 v 6.80633 l -10.7521,-3.46004 z"
               id="mv04_recirculate_line_flow" />
            <path
               style={{
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000000',
                  strokeWidth: 0.290242,
                  strokeDasharray: 'none',
                  strokeDashoffset: 0,
                  strokeOpacity: 0.92
               }}
               d="m 597.52425,657.70982 v 6.80633 l -10.7521,-3.46004 z"
               id="hv10_line_out_flow" />
            <path
               style={{
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000000',
                  strokeWidth: 0.290242,
                  strokeDasharray: 'none',
                  strokeDashoffset: 0,
                  strokeOpacity: 0.92
               }}
               d="m 1276.9141,402.5012 v 6.80633 l -10.7521,-3.46004 z"
               id="hv13_line_out_flow" />
            <text
               id="hv15_label-7"
               style={{
                  fontStyle: 'normal',
                  fontVariant: 'normal',
                  fontWeight: 'normal',
                  fontStretch: 'normal',
                  fontSize: '9.33333px',
                  fontFamily: 'Calibri',
                  fontVariantLigatures: 'normal',
                  fontVariantCaps: 'normal',
                  fontVariantNumeric: 'normal',
                  fontVariantEastAsian: 'normal',
                  whiteSpace: 'pre',
                  shapeInside: 'url(#rect3061-54-9-2-4-4-1-2-3-0-8-1)',
                  display: 'inline',
                  fill: '#000000',
                  fillOpacity: 1,
                  stroke: '#000405',
                  strokeWidth: 0.56,
                  strokeDasharray: 'none'
               }}
               transform="translate(-652.38658,58.57836)"
               className={clslabeltext}><tspan
                  x="943.96875"
                  y="751.5358"
                  id="tspan379"><tspan
                     style={{
                        fontWeight: 300,
                        fontSize: '8px'
                     }}
                     id="tspan378">HH
                  </tspan></tspan><tspan
                     x="943.96875"
                     y="763.20249"
                     id="tspan381"><tspan
                        style={{
                           fontWeight: 300,
                           fontSize: '8px'
                        }}
                        id="tspan380">
                  </tspan></tspan><tspan
                     x="943.96875"
                     y="774.86918"
                     id="tspan383"><tspan
                        style={{
                           fontWeight: 300,
                           fontSize: '8px'
                        }}
                        id="tspan382">H
                  </tspan></tspan><tspan
                     x="943.96875"
                     y="786.53587"
                     id="tspan385"><tspan
                        style={{
                           fontWeight: 300,
                           fontSize: '8px'
                        }}
                        id="tspan384">
                  </tspan></tspan><tspan
                     x="943.96875"
                     y="798.20255"
                     id="tspan387"><tspan
                        style={{
                           fontWeight: 300,
                           fontSize: '8px'
                        }}
                        id="tspan386">L
                  </tspan></tspan><tspan
                     x="943.96875"
                     y="809.86924"
                     id="tspan389"><tspan
                        style={{
                           fontWeight: 300,
                           fontSize: '8px'
                        }}
                        id="tspan388">
                  </tspan></tspan><tspan
                     x="943.96875"
                     y="821.53593"
                     id="tspan391"><tspan
                        style={{
                           fontWeight: 300,
                           fontSize: '8px'
                        }}
                        id="tspan390">LL
                  </tspan></tspan><tspan
                     x="943.96875"
                     y="833.20261"
                     id="tspan393"><tspan
                        style={{
                           fontWeight: 300,
                           fontSize: '8px'
                        }}
                        id="tspan392">
                  </tspan></tspan><tspan
                     x="943.96875"
                     y="844.8693"
                     id="tspan395"><tspan
                        style={{
                           fontWeight: 300,
                           fontSize: '8px'
                        }}
                        id="tspan394">LLL</tspan></tspan></text>
            <g
               id="grp_AE02"
               transform="rotate(-90,414.90583,558.68616)">
               <path
                  style={{
                     fill: '#ffffff',
                     stroke: '#000000',
                     strokeWidth: 0.449978,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }}
                  d="m 584.29321,1465.152 a 16.51177,16.597471 0 0 1 -16.51177,16.5975 16.51177,16.597471 0 0 1 -16.51177,-16.5975 16.51177,16.597471 0 0 1 16.51177,-16.5975 16.51177,16.597471 0 0 1 16.51177,16.5975 z"
                  id="ae02_trubidity_body"
                  className={clsae02_turbidity_body} />
               <path
                  style={{
                     fill: '#ffffff',
                     stroke: '#000000',
                     strokeWidth: 0.449978,
                     strokeLinecap: 'round',
                     strokeLinejoin: 'round',
                     strokeMiterlimit: 10,
                     strokeDasharray: 'none',
                     strokeOpacity: 1
                  }}
                  d="m 567.69714,1448.5368 v 32.7953"
                  id="path15" />
            </g>
         </g>
      </svg>

   );
};

export default AlgaesysSvg;
